import React from 'react';

function partlyCloudy() {
  return (
    <div>
      <svg width="230" height="209" viewBox="0 0 230 209" fill="none">
        <g style={{ 'mix-blend-mode': 'multiply' }}>
          <path
            opacity="0.047619"
            d="M152.76 77.0033C142.694 72.9768 141.687 62.9106 150.747 53.851C155.78 48.8179 163.833 46.8046 172.892 47.8112C182.959 49.8245 186.985 56.8708 180.945 65.9304C174.906 74.99 162.826 80.0231 152.76 77.0033Z"
            fill="#F9FBFB"
          />
          <path
            opacity="0.095238"
            d="M153.767 75.9966C143.7 71.9701 142.694 61.9039 151.753 53.851C156.786 48.8179 164.839 46.8046 173.899 47.8112C183.965 48.8178 187.992 56.8708 180.945 65.9304C174.906 73.9834 162.826 80.0231 153.767 75.9966Z"
            fill="#F3F6F7"
          />
          <path
            opacity="0.1429"
            d="M153.767 75.9966C143.7 72.9768 142.694 62.9105 151.753 54.8576C156.786 50.8311 164.839 47.8112 172.892 48.8178C181.952 49.8245 185.979 57.8774 179.939 65.9304C173.899 73.9834 162.826 79.0165 153.767 75.9966Z"
            fill="#EEF2F4"
          />
          <path
            opacity="0.1905"
            d="M154.773 74.99C144.707 71.9701 144.707 61.9039 152.76 53.851C157.793 49.8245 164.839 46.8046 173.899 48.8178C181.952 50.8311 185.978 57.8774 179.939 65.9304C173.899 72.9768 162.826 78.0099 154.773 74.99Z"
            fill="#E8EDF0"
          />
          <path
            opacity="0.2381"
            d="M154.773 74.99C144.707 71.9701 144.707 61.9039 152.76 54.8576C157.793 50.8311 164.839 48.8178 172.892 49.8245C181.952 50.8311 185.979 57.8774 178.932 65.9304C173.899 72.9768 163.833 78.0099 154.773 74.99Z"
            fill="#E2E9EC"
          />
          <path
            opacity="0.2857"
            d="M154.773 73.9834C145.714 70.9635 144.707 61.9039 152.76 54.8576C157.793 50.8311 164.839 48.8178 172.892 49.8245C181.952 50.8311 184.972 57.8774 178.932 65.9304C172.892 71.9701 163.833 77.0033 154.773 73.9834Z"
            fill="#DCE4E8"
          />
          <path
            opacity="0.3333"
            d="M155.78 73.9834C146.72 71.9701 145.714 61.9039 153.767 54.8576C158.8 50.8311 165.846 48.8178 172.892 49.8245C180.945 50.8311 184.972 57.8774 177.925 64.9238C172.892 71.9701 163.833 75.9966 155.78 73.9834Z"
            fill="#D7E0E5"
          />
          <path
            opacity="0.381"
            d="M155.78 73.9834C146.72 71.9701 146.72 62.9106 153.767 55.8642C158.8 51.8377 165.846 49.8245 172.892 50.8311C180.945 51.8377 183.965 57.8774 177.925 65.9304C172.892 71.9701 163.833 75.9966 155.78 73.9834Z"
            fill="#D1DCE1"
          />
          <path
            opacity="0.4286"
            d="M155.78 72.9768C146.72 70.9635 146.72 61.9039 153.767 55.8642C158.8 51.8377 165.846 49.8245 171.886 50.8311C178.932 51.8377 182.959 57.8774 176.919 64.9238C172.892 70.9635 163.833 74.99 155.78 72.9768Z"
            fill="#CBD7DD"
          />
          <path
            opacity="0.4762"
            d="M156.786 72.9768C147.727 70.9635 147.727 61.9039 154.773 56.8708C159.806 51.8377 166.853 50.8311 172.892 50.8311C179.939 51.8377 182.959 57.8774 176.919 63.9172C171.886 70.9635 163.833 73.9834 156.786 72.9768Z"
            fill="#C5D3D9"
          />
          <path
            opacity="0.5238"
            d="M156.786 71.9701C148.734 69.9569 147.727 61.9039 154.773 55.8642C159.806 51.8377 166.853 50.8311 171.886 51.8377C178.932 52.8443 181.952 57.8774 175.912 64.9238C171.886 69.9569 163.833 73.9834 156.786 71.9701Z"
            fill="#C0CED6"
          />
          <path
            opacity="0.5714"
            d="M156.786 71.9701C148.734 70.9635 147.727 61.9039 154.773 56.8708C159.806 52.8443 165.846 51.8377 171.886 52.8443C177.926 53.851 180.945 58.8841 175.912 64.9238C171.886 69.9569 164.839 72.9768 156.786 71.9701Z"
            fill="#BACAD2"
          />
          <path
            opacity="0.619"
            d="M157.793 70.9635C149.74 69.9569 149.74 61.9039 155.78 56.8708C160.813 52.8443 166.853 51.8377 171.886 52.8443C177.925 53.851 180.945 58.8841 174.906 64.9238C170.879 68.9503 164.839 71.9701 157.793 70.9635Z"
            fill="#B4C5CE"
          />
          <path
            opacity="0.6667"
            d="M157.793 70.9635C149.74 69.9569 149.74 61.9039 155.78 56.8708C160.813 52.8443 166.853 51.8377 171.886 52.8443C177.925 53.851 179.939 57.8774 174.906 63.9172C170.879 68.9503 164.839 70.9635 157.793 70.9635Z"
            fill="#AEC1CA"
          />
          <path
            opacity="0.7143"
            d="M158.8 69.9569C150.747 68.9503 150.747 61.9039 156.786 56.8708C161.82 53.851 167.859 52.8443 171.886 52.8443C176.919 53.851 179.939 57.8774 173.899 63.9172C170.879 67.9437 164.839 70.9635 158.8 69.9569Z"
            fill="#A9BDC7"
          />
          <path
            opacity="0.7619"
            d="M158.8 69.9569C150.747 68.9503 150.747 61.9039 156.786 57.8774C161.82 53.8509 167.859 52.8443 171.886 53.851C176.919 53.851 179.939 58.8841 173.899 63.9172C170.879 67.9437 164.839 69.9569 158.8 69.9569Z"
            fill="#A3B8C3"
          />
          <path
            opacity="0.8095"
            d="M158.8 68.9503C151.753 68.9503 150.747 60.8973 156.786 57.8774C161.82 54.8576 167.859 53.851 171.886 53.851C176.919 53.851 178.932 57.8774 173.899 63.9172C169.873 67.9437 164.839 68.9503 158.8 68.9503Z"
            fill="#9DB4BF"
          />
          <path
            opacity="0.8571"
            d="M159.806 68.9503C152.76 68.9503 152.76 61.9039 157.793 57.8774C162.826 54.8576 168.866 53.851 171.886 53.851C175.912 53.851 178.932 57.8774 172.892 62.9105C169.872 66.937 165.846 68.9503 159.806 68.9503Z"
            fill="#97AFBB"
          />
          <path
            opacity="0.9048"
            d="M159.806 67.9437C152.76 67.9437 152.76 60.8973 157.793 57.8774C162.826 54.8576 167.859 53.8509 171.886 54.8576C175.912 54.8576 177.925 58.8841 172.892 63.9172C169.872 66.937 165.846 67.9437 159.806 67.9437Z"
            fill="#92ABB8"
          />
          <path
            opacity="0.9524"
            d="M159.806 67.9437C152.76 67.9437 152.76 61.9039 157.793 58.8841C162.826 55.8642 167.859 55.8642 170.879 55.8642C174.906 55.8642 176.919 59.8907 171.886 63.9172C168.866 65.9304 165.846 66.937 159.806 67.9437Z"
            fill="#8CA6B4"
          />
          <path
            d="M160.813 66.937C153.767 67.9437 153.767 60.8973 158.8 57.8774C163.833 54.8576 168.866 54.8576 171.886 54.8576C174.906 54.8576 177.925 57.8774 171.886 62.9105C168.866 65.9304 165.846 66.937 160.813 66.937Z"
            fill="#86A2B0"
          />
          <path
            opacity="0.047619"
            d="M139.674 48.8179C129.608 53.851 119.541 44.7914 120.548 32.7119C120.548 25.6656 124.575 18.6192 131.621 12.5795C139.674 6.53975 150.747 13.5861 152.76 23.6523C153.767 34.7252 149.74 44.7914 139.674 48.8179Z"
            fill="#F9FBFB"
          />
          <path
            opacity="0.095238"
            d="M139.674 48.8178C129.608 53.851 120.548 45.798 120.548 32.7119C120.548 25.6655 124.575 18.6192 131.621 13.5861C139.674 7.54635 150.747 13.5861 151.753 24.6589C153.767 34.7251 148.734 43.7847 139.674 48.8178Z"
            fill="#F3F6F7"
          />
          <path
            opacity="0.1429"
            d="M139.674 47.8112C130.614 52.8443 120.548 44.7914 121.555 32.7119C121.555 25.6655 125.581 18.6192 132.628 13.5861C140.681 7.54635 150.747 13.5861 151.753 24.6589C152.76 33.7185 148.734 43.7847 139.674 47.8112Z"
            fill="#EEF2F4"
          />
          <path
            opacity="0.1905"
            d="M139.674 46.8046C130.614 51.8377 121.555 43.7847 121.555 32.7119C121.555 25.6655 125.581 19.6258 132.628 14.5927C139.674 9.55959 149.74 14.5927 150.747 25.6655C151.753 33.7185 147.727 42.7781 139.674 46.8046Z"
            fill="#E8EDF0"
          />
          <path
            opacity="0.2381"
            d="M139.674 45.798C130.614 50.8311 121.555 43.7848 122.561 31.7053C122.561 24.6589 126.588 18.6192 132.628 13.5861C139.674 8.55299 149.74 13.5861 150.747 23.6523C151.753 33.7185 147.727 41.7715 139.674 45.798Z"
            fill="#E2E9EC"
          />
          <path
            opacity="0.2857"
            d="M139.674 45.798C130.614 50.8311 121.555 42.7781 122.561 31.7053C122.561 25.6656 126.588 18.6192 132.628 13.5861C139.674 8.55299 148.733 13.5861 149.74 23.6523C150.747 33.7185 146.72 41.7715 139.674 45.798Z"
            fill="#DCE4E8"
          />
          <path
            opacity="0.3333"
            d="M138.667 44.7913C130.614 49.8245 121.555 42.7781 122.561 31.7053C123.568 25.6655 126.588 18.6192 132.628 14.5927C138.667 9.55958 147.727 14.5927 148.733 24.6589C149.74 32.7119 146.72 40.7649 138.667 44.7913Z"
            fill="#D7E0E5"
          />
          <path
            opacity="0.381"
            d="M138.667 43.7847C130.614 48.8179 122.561 41.7715 123.568 31.7053C124.575 25.6656 127.594 18.6192 133.634 14.5927C139.674 9.55961 148.734 14.5927 148.734 23.6523C149.74 32.7119 145.714 39.7583 138.667 43.7847Z"
            fill="#D1DCE1"
          />
          <path
            opacity="0.4286"
            d="M138.667 43.7847C130.614 48.8178 122.561 41.7715 123.568 31.7053C124.575 25.6655 127.594 19.6258 133.634 15.5993C139.674 10.5662 147.727 15.5993 148.734 24.6589C148.734 32.7119 145.714 39.7582 138.667 43.7847Z"
            fill="#CBD7DD"
          />
          <path
            opacity="0.4762"
            d="M138.667 42.7781C131.621 47.8112 123.568 40.7649 124.575 31.7053C125.581 25.6655 128.601 19.6258 133.634 15.5993C139.674 11.5728 146.72 15.5993 147.727 24.6589C148.733 31.7053 144.707 38.7516 138.667 42.7781Z"
            fill="#C5D3D9"
          />
          <path
            opacity="0.5238"
            d="M138.667 41.7715C131.621 46.8046 124.575 39.7582 125.581 30.6986C126.588 24.6589 129.608 18.6192 134.641 15.5993C139.674 11.5728 147.727 14.5927 147.727 23.6523C147.727 31.7053 144.707 37.745 138.667 41.7715Z"
            fill="#C0CED6"
          />
          <path
            opacity="0.5714"
            d="M137.661 41.7715C130.614 46.8046 123.568 40.7649 124.575 31.7053C125.581 25.6656 128.601 19.6258 133.634 16.606C138.667 12.5795 145.714 15.5993 145.714 24.6589C146.72 31.7053 143.7 37.745 137.661 41.7715Z"
            fill="#BACAD2"
          />
          <path
            opacity="0.619"
            d="M137.661 40.7649C130.614 45.798 124.575 39.7583 125.581 31.7053C126.588 25.6656 130.614 20.6324 134.641 16.606C139.674 12.5795 145.714 15.5993 146.72 24.6589C146.72 30.6987 143.7 36.7384 137.661 40.7649Z"
            fill="#B4C5CE"
          />
          <path
            opacity="0.6667"
            d="M137.661 39.7583C131.621 44.7914 124.575 38.7516 125.581 30.6987C126.588 24.6589 130.614 19.6258 133.634 16.606C138.667 12.5795 144.707 15.5993 144.707 23.6523C145.714 30.6987 142.694 35.7318 137.661 39.7583Z"
            fill="#AEC1CA"
          />
          <path
            opacity="0.7143"
            d="M137.661 39.7583C131.621 44.7914 125.581 38.7516 126.588 30.6987C127.595 24.6589 131.621 19.6258 134.641 16.606C138.667 13.5861 144.707 15.5993 144.707 23.6523C144.707 30.6987 142.694 35.7318 137.661 39.7583Z"
            fill="#A9BDC7"
          />
          <path
            opacity="0.7619"
            d="M137.661 38.7516C131.621 43.7847 125.581 37.745 127.594 30.6987C127.594 25.6656 131.621 20.6324 134.641 17.6126C138.667 14.5927 143.7 16.606 143.7 24.6589C144.707 29.692 141.687 34.7251 137.661 38.7516Z"
            fill="#A3B8C3"
          />
          <path
            opacity="0.8095"
            d="M136.654 37.745C131.621 42.7781 125.581 37.745 126.588 30.6987C127.594 24.6589 131.621 20.6324 134.641 17.6126C138.667 14.5927 143.7 16.606 143.7 24.6589C143.7 29.692 141.687 33.7185 136.654 37.745Z"
            fill="#9DB4BF"
          />
          <path
            opacity="0.8571"
            d="M136.654 37.745C131.621 42.7781 126.588 37.745 127.595 30.6987C128.601 24.6589 132.628 20.6325 134.641 18.6192C137.661 15.5993 142.694 17.6126 142.694 24.6589C143.7 29.692 140.681 33.7185 136.654 37.745Z"
            fill="#97AFBB"
          />
          <path
            opacity="0.9048"
            d="M136.654 36.7384C131.621 41.7715 126.588 36.7384 127.595 30.6987C128.601 24.6589 132.628 20.6325 134.641 18.6192C137.661 15.5993 141.687 17.6126 141.687 24.6589C142.694 29.692 140.681 32.7119 136.654 36.7384Z"
            fill="#92ABB8"
          />
          <path
            opacity="0.9524"
            d="M136.654 35.7318C131.621 40.7649 127.595 35.7318 128.601 30.6987C129.608 24.6589 133.634 20.6324 135.647 18.6192C138.667 15.5993 142.694 16.606 142.694 24.6589C141.687 28.6854 140.681 31.7053 136.654 35.7318Z"
            fill="#8CA6B4"
          />
          <path
            d="M136.654 35.7318C131.621 40.7649 127.595 35.7318 128.601 30.6986C129.608 24.6589 133.634 20.6324 135.647 19.6258C138.667 16.6059 141.687 17.6126 141.687 24.6589C141.687 28.6854 139.674 31.7053 136.654 35.7318Z"
            fill="#86A2B0"
          />
          <path
            opacity="0.047619"
            d="M107.462 37.745C104.442 47.8112 93.3694 48.8179 84.3098 40.7649C79.2767 35.7318 76.2568 27.6788 77.2635 18.6192C78.2701 8.55299 89.3429 6.53975 99.4091 12.5795C107.462 18.6192 110.482 27.6788 107.462 37.745Z"
            fill="#F9FBFB"
          />
          <path
            opacity="0.095238"
            d="M106.456 36.7384C103.436 46.8046 93.3695 48.8179 84.3099 39.7583C80.2834 35.7318 77.2635 27.6788 77.2635 18.6192C78.2701 8.553 89.343 7.54638 98.4026 13.5861C107.462 19.6258 109.475 27.6788 106.456 36.7384Z"
            fill="#F3F6F7"
          />
          <path
            opacity="0.1429"
            d="M106.456 36.7384C103.436 46.8046 93.3695 47.8112 85.3165 39.7583C80.2834 34.7252 77.2635 27.6788 78.2701 18.6192C79.2768 9.55962 89.343 7.54637 98.4026 13.5861C106.456 19.6258 108.469 27.6788 106.456 36.7384Z"
            fill="#EEF2F4"
          />
          <path
            opacity="0.1905"
            d="M105.449 36.7384C103.436 46.8046 93.3695 47.8112 84.3099 39.7583C79.2768 34.7252 77.2635 27.6788 77.2635 19.6258C78.2701 10.5662 88.3363 8.553 96.3893 14.5927C105.449 19.6258 108.469 26.6722 105.449 36.7384Z"
            fill="#E8EDF0"
          />
          <path
            opacity="0.2381"
            d="M105.449 35.7318C103.436 45.798 93.3694 46.8046 85.3164 38.7516C80.2833 33.7185 78.2701 26.6722 78.2701 18.6192C79.2767 9.5596 89.3429 8.55298 97.3959 13.5861C105.449 19.6258 107.462 26.6722 105.449 35.7318Z"
            fill="#E2E9EC"
          />
          <path
            opacity="0.2857"
            d="M104.442 35.7318C102.429 45.798 92.3628 46.8046 85.3165 38.7517C81.29 33.7185 78.2701 26.6722 79.2768 19.6258C80.2834 11.5729 89.343 9.55962 97.396 15.5994C104.442 19.6258 106.456 26.6722 104.442 35.7318Z"
            fill="#DCE4E8"
          />
          <path
            opacity="0.3333"
            d="M104.442 35.7318C102.429 44.7914 93.3694 45.798 86.3231 38.7517C81.29 33.7185 79.2767 26.6722 79.2767 19.6258C80.2834 11.5729 89.3429 9.55962 96.3893 15.5994C104.442 19.6258 106.456 26.6722 104.442 35.7318Z"
            fill="#D7E0E5"
          />
          <path
            opacity="0.381"
            d="M103.436 34.7252C101.422 43.7848 92.3627 44.7914 85.3164 37.745C81.2899 32.7119 79.2766 26.6722 80.2833 19.6258C81.2899 11.5729 89.3429 9.55962 97.3958 15.5994C103.436 20.6325 105.449 26.6722 103.436 34.7252Z"
            fill="#D1DCE1"
          />
          <path
            opacity="0.4286"
            d="M103.436 34.7251C102.429 43.7847 93.3693 44.7914 86.323 37.745C82.2965 32.7119 79.2766 25.6656 80.2833 19.6258C80.2833 12.5795 89.3429 10.5662 96.3892 15.5993C102.429 20.6324 104.442 26.6722 103.436 34.7251Z"
            fill="#CBD7DD"
          />
          <path
            opacity="0.4762"
            d="M102.429 34.7251C101.422 43.7847 92.3627 44.7914 86.323 37.745C82.2965 32.7119 80.2832 25.6656 80.2832 19.6258C81.2899 12.5795 88.3362 10.5662 96.3892 15.5993C102.429 20.6324 104.442 26.6722 102.429 34.7251Z"
            fill="#C5D3D9"
          />
          <path
            opacity="0.5238"
            d="M102.429 33.7185C101.422 42.7781 92.3628 43.7848 86.323 36.7384C82.2966 31.7053 80.2833 25.6656 81.2899 19.6258C81.2899 12.5795 88.3363 10.5662 95.3826 16.606C101.422 20.6325 103.436 26.6722 102.429 33.7185Z"
            fill="#C0CED6"
          />
          <path
            opacity="0.5714"
            d="M101.422 33.7185C101.422 41.7715 92.3628 42.7781 86.323 36.7384C82.2966 31.7053 81.2899 25.6656 81.2899 19.6258C81.2899 13.5861 88.3363 11.5729 95.3826 16.606C100.416 20.6325 102.429 26.6722 101.422 33.7185Z"
            fill="#BACAD2"
          />
          <path
            opacity="0.619"
            d="M101.422 33.7185C100.416 41.7715 92.3628 42.7781 87.3297 35.7318C83.3032 31.7053 81.2899 24.6589 81.2899 19.6258C81.2899 13.5861 88.3363 11.5729 94.376 16.606C100.416 20.6325 101.422 25.6656 101.422 33.7185Z"
            fill="#B4C5CE"
          />
          <path
            opacity="0.6667"
            d="M100.416 32.7119C100.416 40.7649 92.3628 41.7715 87.3297 35.7318C83.3032 30.6987 82.2966 24.659 82.2966 19.6258C82.2966 13.5861 88.3363 11.5729 95.3827 17.6126C99.4092 21.6391 101.422 25.6656 100.416 32.7119Z"
            fill="#AEC1CA"
          />
          <path
            opacity="0.7143"
            d="M100.416 32.7119C100.416 40.7649 92.3628 40.7649 87.3297 34.7252C83.3032 30.6987 82.2966 24.6589 82.2966 19.6258C82.2966 14.5927 88.3363 12.5795 94.3761 17.6126C99.4092 21.6391 100.416 25.6656 100.416 32.7119Z"
            fill="#A9BDC7"
          />
          <path
            opacity="0.7619"
            d="M99.4092 32.7119C99.4092 40.7649 92.3628 40.7649 87.3297 34.7252C84.3099 29.6921 82.2966 23.6523 82.2966 19.6258C82.2966 14.5927 87.3297 12.5795 93.3694 17.6126C98.4026 21.6391 99.4092 25.6656 99.4092 32.7119Z"
            fill="#A3B8C3"
          />
          <path
            opacity="0.8095"
            d="M99.4091 31.7053C99.4091 38.7516 92.3627 39.7583 88.3362 33.7185C84.3098 28.6854 83.3031 23.6523 83.3031 19.6258C83.3031 14.5927 88.3362 12.5795 94.376 17.6126C97.3958 21.6391 99.4091 25.6656 99.4091 31.7053Z"
            fill="#9DB4BF"
          />
          <path
            opacity="0.8571"
            d="M98.4026 31.7053C98.4026 38.7516 91.3562 39.7583 87.3297 33.7185C83.3032 28.6854 82.2966 23.6523 82.2966 19.6258C82.2966 15.5993 86.3231 12.5795 92.3628 17.6126C97.3959 21.6391 98.4026 25.6656 98.4026 31.7053Z"
            fill="#97AFBB"
          />
          <path
            opacity="0.9048"
            d="M98.4025 31.7053C99.4091 38.7517 92.3628 38.7517 88.3363 33.7186C84.3098 28.6854 84.3098 23.6523 84.3098 20.6325C84.3098 16.606 88.3363 14.5927 93.3694 19.6258C96.3893 21.6391 97.3959 25.6656 98.4025 31.7053Z"
            fill="#92ABB8"
          />
          <path
            opacity="0.9524"
            d="M97.3959 30.6987C98.4025 37.745 91.3562 37.745 88.3363 32.7119C85.3164 28.6854 84.3098 22.6457 84.3098 20.6325C84.3098 16.606 87.3297 14.5927 93.3694 19.6258C95.3826 21.6391 97.3959 25.6656 97.3959 30.6987Z"
            fill="#8CA6B4"
          />
          <path
            d="M97.3959 30.6987C98.4025 37.745 91.3562 37.745 88.3363 32.7119C85.3164 27.6788 84.3098 22.6457 84.3098 20.6324C84.3098 17.6126 87.3297 14.5927 92.3628 19.6258C95.3827 22.6457 96.3893 25.6656 97.3959 30.6987Z"
            fill="#86A2B0"
          />
          <path
            opacity="0.047619"
            d="M145.714 109.215C140.681 99.1489 146.72 91.096 159.806 91.096C166.853 91.096 173.899 94.1158 179.939 101.162C185.979 109.215 183.965 118.275 173.899 120.288C162.826 121.295 149.74 118.275 145.714 109.215Z"
            fill="#F9FBFB"
          />
          <path
            opacity="0.095238"
            d="M145.714 109.215C140.681 99.1489 146.72 91.096 159.806 91.096C166.853 91.096 173.899 94.1158 179.939 101.162C185.979 109.215 183.965 117.268 173.899 119.281C162.826 121.295 150.747 117.268 145.714 109.215Z"
            fill="#F3F6F7"
          />
          <path
            opacity="0.1429"
            d="M146.72 108.209C141.687 99.1489 147.727 91.096 159.806 91.096C166.853 91.096 173.899 94.1158 178.932 101.162C184.972 108.209 182.959 116.262 172.892 118.275C162.826 120.288 151.753 117.268 146.72 108.209Z"
            fill="#EEF2F4"
          />
          <path
            opacity="0.1905"
            d="M146.72 108.209C141.687 99.1489 147.727 91.096 159.806 91.096C166.853 91.096 173.899 94.1158 178.932 101.162C184.972 108.209 182.959 116.262 172.892 118.275C162.826 120.288 151.753 116.262 146.72 108.209Z"
            fill="#E8EDF0"
          />
          <path
            opacity="0.2381"
            d="M147.727 108.209C142.694 99.1489 148.734 92.1026 159.806 92.1026C166.853 92.1026 172.893 95.1225 178.932 101.162C184.972 108.209 182.959 115.255 172.893 117.268C162.826 119.281 152.76 116.262 147.727 108.209Z"
            fill="#E2E9EC"
          />
          <path
            opacity="0.2857"
            d="M148.734 108.209C143.7 100.156 149.74 92.1026 160.813 92.1026C166.853 92.1026 173.899 95.1225 178.932 101.162C183.965 107.202 182.959 115.255 172.892 116.262C162.826 119.281 152.76 116.262 148.734 108.209Z"
            fill="#DCE4E8"
          />
          <path
            opacity="0.3333"
            d="M148.734 108.209C143.7 100.156 149.74 93.1092 159.806 93.1092C165.846 93.1092 172.892 96.1291 177.926 102.169C182.959 108.209 181.952 115.255 171.886 117.268C163.833 118.275 153.767 115.255 148.734 108.209Z"
            fill="#D7E0E5"
          />
          <path
            opacity="0.381"
            d="M149.74 108.209C144.707 100.156 149.74 93.1092 160.813 94.1158C166.853 94.1158 173.899 98.1423 177.926 103.175C182.959 109.215 181.952 116.262 171.886 117.268C163.833 118.275 153.767 115.255 149.74 108.209Z"
            fill="#D1DCE1"
          />
          <path
            opacity="0.4286"
            d="M149.74 108.209C144.707 101.162 149.74 94.1158 159.806 94.1158C165.846 94.1158 172.892 98.1423 176.919 103.175C181.952 109.215 179.939 115.255 170.879 117.268C163.833 117.268 154.773 114.248 149.74 108.209Z"
            fill="#CBD7DD"
          />
          <path
            opacity="0.4762"
            d="M150.747 108.209C145.714 101.162 150.747 94.1158 160.813 95.1225C166.853 95.1225 172.892 99.1489 176.919 103.175C181.952 108.209 179.939 115.255 170.879 116.262C163.833 117.268 155.78 114.248 150.747 108.209Z"
            fill="#C5D3D9"
          />
          <path
            opacity="0.5238"
            d="M150.747 107.202C145.714 100.156 150.747 94.1158 159.806 94.1158C165.846 94.1158 171.886 98.1423 175.912 102.169C179.939 107.202 178.932 113.242 169.873 114.248C163.833 116.262 155.78 114.248 150.747 107.202Z"
            fill="#C0CED6"
          />
          <path
            opacity="0.5714"
            d="M151.753 107.202C146.72 100.156 151.753 94.1158 160.813 95.1225C166.853 95.1225 172.893 99.1489 176.919 103.175C180.946 108.209 179.939 114.248 170.879 115.255C163.833 115.255 156.787 113.242 151.753 107.202Z"
            fill="#BACAD2"
          />
          <path
            opacity="0.619"
            d="M152.76 107.202C147.727 101.162 152.76 94.1158 160.813 95.1224C166.853 96.1291 172.893 99.1489 175.912 103.175C179.939 108.209 178.932 113.242 169.873 114.248C163.833 115.255 156.787 113.242 152.76 107.202Z"
            fill="#B4C5CE"
          />
          <path
            opacity="0.6667"
            d="M152.76 107.202C147.727 101.162 152.76 95.1224 160.813 96.1291C166.853 97.1357 171.886 100.156 175.912 104.182C179.939 108.209 178.932 114.248 170.879 114.248C163.833 114.248 157.793 112.235 152.76 107.202Z"
            fill="#AEC1CA"
          />
          <path
            opacity="0.7143"
            d="M153.767 107.202C148.733 101.162 153.767 95.1224 160.813 96.1291C166.853 97.1357 171.886 100.156 174.906 103.175C178.932 107.202 177.925 112.235 169.873 113.242C163.833 114.248 157.793 112.235 153.767 107.202Z"
            fill="#A9BDC7"
          />
          <path
            opacity="0.7619"
            d="M153.767 107.202C148.733 102.169 153.767 96.1291 160.813 97.1357C166.853 98.1423 171.886 101.162 174.906 104.182C177.925 108.209 177.925 113.242 169.873 113.242C163.833 113.242 158.8 111.228 153.767 107.202Z"
            fill="#A3B8C3"
          />
          <path
            opacity="0.8095"
            d="M154.773 107.202C149.74 102.169 153.767 96.1291 160.813 97.1357C166.853 98.1423 171.886 101.162 173.899 104.182C176.919 107.202 175.912 112.235 168.866 113.242C163.833 113.242 158.8 111.228 154.773 107.202Z"
            fill="#9DB4BF"
          />
          <path
            opacity="0.8571"
            d="M155.78 107.202C150.747 102.169 154.773 97.1357 161.82 98.1423C167.859 99.1489 171.886 102.169 174.906 105.189C177.926 108.209 176.919 113.242 169.873 113.242C163.833 112.235 159.806 111.228 155.78 107.202Z"
            fill="#97AFBB"
          />
          <path
            opacity="0.9048"
            d="M155.78 107.202C150.747 102.169 154.773 97.1357 160.813 98.1423C166.853 99.1489 170.879 102.169 172.893 104.182C175.912 107.202 174.906 111.228 167.859 111.228C163.833 112.235 160.813 110.222 155.78 107.202Z"
            fill="#92ABB8"
          />
          <path
            opacity="0.9524"
            d="M156.786 106.195C151.753 102.169 155.78 97.1357 161.82 98.1423C167.859 99.1489 171.886 102.169 173.899 104.182C176.919 107.202 175.912 111.228 168.866 111.228C164.839 111.228 160.813 110.222 156.786 106.195Z"
            fill="#8CA6B4"
          />
          <path
            d="M156.786 106.195C151.753 102.169 155.78 98.1423 161.82 99.1489C167.859 100.156 171.886 103.175 173.899 105.189C176.919 107.202 175.912 111.228 168.866 111.228C164.839 111.228 161.82 109.215 156.786 106.195Z"
            fill="#86A2B0"
          />
          <path
            opacity="0.047619"
            d="M119.541 125.321C122.561 115.255 133.634 113.242 142.694 122.301C147.727 127.334 150.747 134.381 149.74 144.447C148.733 154.513 140.681 159.546 131.621 152.5C122.561 146.46 116.522 135.387 119.541 125.321Z"
            fill="#F9FBFB"
          />
          <path
            opacity="0.095238"
            d="M119.541 125.321C122.561 115.255 132.628 114.248 141.687 122.301C146.72 127.334 149.74 134.381 148.733 143.44C147.727 153.507 139.674 157.533 131.621 151.493C122.561 146.46 116.522 135.387 119.541 125.321Z"
            fill="#F3F6F7"
          />
          <path
            opacity="0.1429"
            d="M120.548 125.321C123.568 115.255 133.634 114.248 141.687 122.301C146.72 127.334 148.734 134.381 148.734 143.44C147.727 152.5 140.681 157.533 131.621 151.493C123.568 145.454 117.528 135.387 120.548 125.321Z"
            fill="#EEF2F4"
          />
          <path
            opacity="0.1905"
            d="M120.548 126.328C123.568 116.262 133.634 115.255 141.687 123.308C146.72 128.341 148.734 135.387 147.727 143.44C146.72 152.5 139.674 157.533 131.621 151.493C123.568 145.454 118.535 135.387 120.548 126.328Z"
            fill="#E8EDF0"
          />
          <path
            opacity="0.2381"
            d="M120.548 126.328C122.561 116.262 132.628 115.255 140.681 123.308C145.714 128.341 147.727 135.387 146.72 142.434C145.714 151.493 138.667 155.52 130.614 149.48C123.568 144.447 118.535 135.387 120.548 126.328Z"
            fill="#E2E9EC"
          />
          <path
            opacity="0.2857"
            d="M121.555 126.328C123.568 117.268 133.634 116.262 141.687 124.314C145.714 129.348 148.734 135.387 147.727 143.44C146.72 151.493 140.681 156.526 132.628 150.487C124.575 144.447 119.542 135.387 121.555 126.328Z"
            fill="#DCE4E8"
          />
          <path
            opacity="0.3333"
            d="M121.555 126.328C123.568 117.268 133.634 116.262 140.681 124.314C144.707 129.348 146.72 135.387 146.72 142.434C145.714 150.487 139.674 154.513 131.621 149.48C124.575 144.447 119.542 135.387 121.555 126.328Z"
            fill="#D7E0E5"
          />
          <path
            opacity="0.381"
            d="M122.561 126.328C124.575 117.268 133.634 116.262 140.681 124.314C144.707 129.348 146.72 135.387 146.72 142.434C145.714 150.487 139.674 154.513 131.621 148.473C124.575 143.44 120.548 135.387 122.561 126.328Z"
            fill="#D1DCE1"
          />
          <path
            opacity="0.4286"
            d="M122.561 127.334C124.575 118.275 133.634 117.268 140.681 125.321C144.707 130.354 146.72 136.394 145.714 142.434C144.707 149.48 138.667 154.513 131.621 148.473C125.581 143.44 121.555 135.387 122.561 127.334Z"
            fill="#CBD7DD"
          />
          <path
            opacity="0.4762"
            d="M122.561 127.334C123.568 118.275 133.634 118.275 139.674 125.321C143.701 130.354 145.714 136.394 144.707 142.434C143.701 149.48 138.667 153.507 130.614 148.473C125.581 142.434 121.555 135.387 122.561 127.334Z"
            fill="#C5D3D9"
          />
          <path
            opacity="0.5238"
            d="M123.568 127.334C124.575 118.275 133.634 118.275 139.674 125.321C143.7 130.354 145.714 135.387 144.707 141.427C143.7 148.473 138.667 152.5 131.621 146.46C125.581 142.434 122.561 135.387 123.568 127.334Z"
            fill="#C0CED6"
          />
          <path
            opacity="0.5714"
            d="M123.568 127.334C124.575 119.281 133.634 118.275 139.674 125.321C143.7 130.354 144.707 135.387 144.707 141.427C144.707 147.467 138.667 151.493 131.621 146.46C126.588 141.427 122.561 135.387 123.568 127.334Z"
            fill="#BACAD2"
          />
          <path
            opacity="0.619"
            d="M124.575 127.334C125.581 119.281 134.641 118.275 139.674 125.321C143.7 130.354 144.707 135.387 144.707 140.42C144.707 146.46 138.667 150.487 132.628 145.454C126.588 141.427 123.568 134.381 124.575 127.334Z"
            fill="#B4C5CE"
          />
          <path
            opacity="0.6667"
            d="M124.575 128.341C125.581 120.288 133.634 120.288 138.667 126.328C142.694 131.361 143.7 136.394 143.7 141.427C143.7 147.467 138.667 151.493 131.621 145.454C126.588 140.42 124.575 134.381 124.575 128.341Z"
            fill="#AEC1CA"
          />
          <path
            opacity="0.7143"
            d="M124.575 128.341C124.575 120.288 133.634 120.288 138.667 126.328C142.694 131.361 143.7 136.394 142.694 140.42C142.694 145.454 137.661 149.48 131.621 144.447C127.595 140.42 124.575 134.381 124.575 128.341Z"
            fill="#A9BDC7"
          />
          <path
            opacity="0.7619"
            d="M125.581 128.341C125.581 120.288 133.634 120.288 138.667 126.328C142.694 131.361 142.694 135.387 142.694 139.414C142.694 144.447 137.661 148.473 131.621 143.44C127.594 140.42 125.581 134.381 125.581 128.341Z"
            fill="#A3B8C3"
          />
          <path
            opacity="0.8095"
            d="M125.581 128.341C125.581 121.295 133.634 120.288 137.661 126.328C141.687 131.361 141.687 135.387 141.687 139.414C141.687 144.447 136.654 147.467 131.621 142.434C127.594 139.414 125.581 134.381 125.581 128.341Z"
            fill="#9DB4BF"
          />
          <path
            opacity="0.8571"
            d="M126.588 129.348C126.588 122.301 134.641 122.301 138.667 127.334C141.687 131.361 141.687 136.394 141.687 139.414C141.687 143.44 137.661 147.467 131.621 142.434C128.601 139.414 126.588 134.381 126.588 129.348Z"
            fill="#97AFBB"
          />
          <path
            opacity="0.9048"
            d="M126.588 129.348C126.588 122.301 133.634 122.301 137.661 127.334C140.681 132.367 141.687 136.394 141.687 139.414C141.687 143.44 137.661 147.467 132.628 142.434C128.601 138.407 126.588 134.381 126.588 129.348Z"
            fill="#92ABB8"
          />
          <path
            opacity="0.9524"
            d="M127.595 129.348C126.588 122.301 134.641 122.301 137.661 127.334C140.681 132.367 140.681 136.394 140.681 138.407C140.681 142.434 136.654 145.454 131.621 140.42C128.601 138.407 127.595 134.381 127.595 129.348Z"
            fill="#8CA6B4"
          />
          <path
            d="M127.595 129.348C126.588 122.301 134.641 123.308 137.661 127.334C140.681 132.367 140.681 135.387 140.681 138.407C140.681 141.427 136.654 145.454 131.621 140.42C129.608 137.401 128.601 134.381 127.595 129.348Z"
            fill="#86A2B0"
          />
          <path
            opacity="0.047619"
            d="M87.3296 120.288C96.3892 115.255 105.449 121.295 106.455 133.374C106.455 140.42 104.442 148.473 97.3958 154.513C89.3429 161.56 81.2899 159.546 78.27 148.473C75.2501 138.407 78.27 125.321 87.3296 120.288Z"
            fill="#F9FBFB"
          />
          <path
            opacity="0.095238"
            d="M87.3297 121.295C96.3893 116.262 104.442 121.295 105.449 134.381C105.449 141.427 102.429 148.473 96.3893 154.513C89.3429 161.559 80.2833 159.546 78.2701 149.48C76.2568 138.407 79.2767 126.328 87.3297 121.295Z"
            fill="#F3F6F7"
          />
          <path
            opacity="0.1429"
            d="M87.3297 121.295C96.3893 116.262 104.442 121.295 105.449 133.374C105.449 140.42 102.429 147.467 96.3893 153.507C89.3429 159.546 81.2899 158.54 78.2701 148.473C76.2568 138.407 79.2767 126.328 87.3297 121.295Z"
            fill="#EEF2F4"
          />
          <path
            opacity="0.1905"
            d="M87.3296 121.295C95.3826 116.262 103.436 121.295 104.442 133.374C104.442 140.42 101.422 147.467 95.3826 152.5C88.3362 158.54 80.2833 157.533 78.27 147.467C77.2634 138.407 80.2833 126.328 87.3296 121.295Z"
            fill="#E8EDF0"
          />
          <path
            opacity="0.2381"
            d="M87.3296 122.301C95.3825 117.268 103.436 122.301 103.436 133.374C103.436 139.414 100.416 147.467 95.3825 152.5C89.3428 158.54 81.2898 157.533 79.2766 147.467C77.2633 138.407 80.2832 126.328 87.3296 122.301Z"
            fill="#E2E9EC"
          />
          <path
            opacity="0.2857"
            d="M88.3363 122.301C96.3893 117.268 103.436 122.301 104.442 133.374C104.442 139.414 101.422 146.46 96.3893 151.493C90.3495 157.533 82.2966 156.526 80.2833 146.46C78.2701 137.401 80.2833 127.334 88.3363 122.301Z"
            fill="#DCE4E8"
          />
          <path
            opacity="0.3333"
            d="M88.3362 123.308C95.3826 118.275 103.436 123.308 103.436 133.374C103.436 139.414 100.416 146.46 95.3826 151.493C89.3429 157.533 82.2965 156.526 80.2833 146.46C78.27 137.401 81.2899 127.334 88.3362 123.308Z"
            fill="#D7E0E5"
          />
          <path
            opacity="0.381"
            d="M88.3363 123.308C95.3826 118.275 102.429 122.301 103.436 133.374C103.436 139.414 100.416 146.46 95.3826 151.493C89.3429 156.526 82.2965 155.52 80.2833 146.46C79.2767 137.401 81.2899 127.334 88.3363 123.308Z"
            fill="#D1DCE1"
          />
          <path
            opacity="0.4286"
            d="M88.3362 123.308C95.3826 119.281 102.429 122.301 102.429 132.367C102.429 138.407 99.4091 145.454 94.3759 149.48C89.3428 154.513 82.2965 153.507 80.2832 144.447C79.2766 137.401 82.2965 128.341 88.3362 123.308Z"
            fill="#CBD7DD"
          />
          <path
            opacity="0.4762"
            d="M88.3362 124.314C94.376 120.288 101.422 123.308 102.429 133.374C102.429 139.414 99.4091 145.454 95.3826 150.487C90.3495 155.52 83.3031 154.513 82.2965 145.454C80.2833 137.401 82.2965 128.341 88.3362 124.314Z"
            fill="#C5D3D9"
          />
          <path
            opacity="0.5238"
            d="M88.3362 124.314C94.3759 120.288 101.422 123.308 101.422 132.367C101.422 138.407 98.4024 144.447 94.3759 148.473C89.3428 153.507 83.3031 152.5 81.2898 143.44C80.2832 137.401 82.2964 128.341 88.3362 124.314Z"
            fill="#C0CED6"
          />
          <path
            opacity="0.5714"
            d="M88.3362 125.321C94.376 121.295 100.416 124.314 100.416 133.374C100.416 139.414 97.3958 145.454 93.3693 149.48C88.3362 153.507 82.2965 153.507 81.2899 144.447C80.2833 137.401 83.3031 128.341 88.3362 125.321Z"
            fill="#BACAD2"
          />
          <path
            opacity="0.619"
            d="M88.3362 125.321C93.3694 121.295 100.416 124.314 100.416 132.367C100.416 138.407 97.3958 144.447 93.3694 147.467C89.3429 151.493 83.3031 151.493 82.2965 142.434C81.2899 136.394 83.3031 129.348 88.3362 125.321Z"
            fill="#B4C5CE"
          />
          <path
            opacity="0.6667"
            d="M88.3362 125.321C93.3693 121.295 99.4091 123.308 99.4091 132.367C99.4091 138.407 96.3892 143.44 93.3693 147.467C89.3428 151.493 83.3031 151.493 82.2965 143.44C81.2899 136.394 84.3097 129.348 88.3362 125.321Z"
            fill="#AEC1CA"
          />
          <path
            opacity="0.7143"
            d="M88.3363 126.328C93.3694 122.301 99.4091 124.314 99.4091 132.367C99.4091 138.407 96.3892 143.44 93.3694 146.46C89.3429 150.487 84.3098 150.487 83.3032 142.434C82.2965 136.394 84.3098 129.348 88.3363 126.328Z"
            fill="#A9BDC7"
          />
          <path
            opacity="0.7619"
            d="M88.3362 126.328C92.3627 122.301 98.4024 124.314 98.4024 131.361C98.4024 137.401 95.3825 142.434 92.3627 145.454C88.3362 149.48 83.3031 149.48 82.2965 141.427C82.2965 136.394 84.3097 130.354 88.3362 126.328Z"
            fill="#A3B8C3"
          />
          <path
            opacity="0.8095"
            d="M88.3362 127.334C92.3627 124.314 97.3958 125.321 98.4025 132.367C98.4025 138.407 95.3826 143.44 92.3627 145.454C89.3429 148.473 84.3098 149.48 83.3031 141.427C83.3031 136.394 85.3164 130.354 88.3362 127.334Z"
            fill="#9DB4BF"
          />
          <path
            opacity="0.8571"
            d="M89.3428 127.334C93.3693 124.314 98.4024 125.321 98.4024 131.361C98.4024 137.401 95.3825 141.427 92.3627 144.447C89.3428 147.467 84.3097 147.467 84.3097 140.42C83.3031 136.394 85.3163 130.354 89.3428 127.334Z"
            fill="#97AFBB"
          />
          <path
            opacity="0.9048"
            d="M89.3428 127.334C92.3627 124.314 97.3958 125.321 97.3958 131.361C97.3958 137.401 94.3759 141.427 92.3627 144.447C89.3428 147.467 85.3163 147.467 84.3097 140.42C84.3097 135.387 86.3229 130.354 89.3428 127.334Z"
            fill="#92ABB8"
          />
          <path
            opacity="0.9524"
            d="M89.3428 128.341C92.3627 125.321 97.3958 125.321 97.3958 131.361C97.3958 136.394 94.3759 141.427 92.3627 143.44C89.3428 146.46 85.3163 146.46 85.3163 139.414C84.3097 135.387 86.323 131.361 89.3428 128.341Z"
            fill="#8CA6B4"
          />
          <path
            d="M89.3428 128.341C92.3627 125.321 96.3891 125.321 96.3891 131.361C96.3891 136.394 93.3693 141.427 91.356 143.44C89.3428 146.46 85.3163 146.46 84.3097 139.414C85.3163 135.387 86.3229 131.361 89.3428 128.341Z"
            fill="#86A2B0"
          />
          <path
            opacity="0.047619"
            d="M68.2039 93.1092C79.2767 95.1225 82.2966 103.175 74.2436 114.248C70.2171 120.288 62.1641 122.301 52.0979 123.308C42.0317 124.314 35.992 117.268 41.0251 107.202C46.0582 96.1291 58.1376 91.096 68.2039 93.1092Z"
            fill="#F9FBFB"
          />
          <path
            opacity="0.095238"
            d="M68.2038 93.1092C78.27 95.1225 81.2899 103.175 74.2436 113.242C70.2171 118.275 62.1641 121.295 53.1045 121.295C43.0383 122.301 38.0052 115.255 42.0317 105.189C47.0648 97.1357 58.1376 92.1026 68.2038 93.1092Z"
            fill="#F3F6F7"
          />
          <path
            opacity="0.1429"
            d="M67.1972 93.1092C77.2635 94.1158 80.2833 102.169 73.237 112.235C70.2171 118.275 61.1575 120.288 53.1045 121.295C44.0449 122.301 38.0052 115.255 43.0383 106.195C47.0648 97.1357 58.1377 92.1026 67.1972 93.1092Z"
            fill="#EEF2F4"
          />
          <path
            opacity="0.1905"
            d="M67.1972 94.1158C77.2634 95.1225 80.2833 103.175 73.2369 112.235C69.2104 117.268 61.1574 120.288 53.1045 120.288C44.0449 121.295 39.0118 114.248 43.0383 105.189C47.0647 97.1357 58.1376 92.1026 67.1972 94.1158Z"
            fill="#E8EDF0"
          />
          <path
            opacity="0.2381"
            d="M67.1971 94.1158C76.2567 95.1225 79.2766 102.169 73.2368 112.235C69.2104 117.268 61.1574 120.288 53.1044 120.288C44.0448 121.295 39.0117 115.255 44.0448 106.195C48.0713 97.1357 58.1375 93.1092 67.1971 94.1158Z"
            fill="#E2E9EC"
          />
          <path
            opacity="0.2857"
            d="M67.1972 94.1158C76.2568 95.1225 79.2766 102.169 73.2369 111.228C69.2104 116.262 61.1575 119.281 54.1111 119.281C46.0581 120.288 40.0184 114.248 45.0515 105.189C48.0714 97.1357 58.1376 93.1092 67.1972 94.1158Z"
            fill="#DCE4E8"
          />
          <path
            opacity="0.3333"
            d="M66.1905 94.1158C75.2501 95.1225 78.27 102.169 72.2302 110.222C68.2038 115.255 61.1574 117.268 53.1044 118.275C45.0514 119.281 40.0183 113.242 44.0448 105.189C49.0779 97.1357 58.1375 94.1158 66.1905 94.1158Z"
            fill="#D7E0E5"
          />
          <path
            opacity="0.381"
            d="M66.1905 95.1224C74.2435 96.1291 77.2633 102.169 71.2236 110.222C67.1971 115.255 60.1508 117.268 53.1044 118.275C45.0514 119.281 40.0183 113.242 45.0514 105.189C49.0779 98.1423 58.1375 94.1158 66.1905 95.1224Z"
            fill="#D1DCE1"
          />
          <path
            opacity="0.4286"
            d="M66.1906 95.1224C74.2436 96.1291 77.2635 102.169 71.2237 110.222C67.1972 115.255 60.1509 117.268 54.1112 118.275C47.0648 119.281 42.0317 114.248 46.0582 105.189C50.0847 98.1423 59.1443 94.1158 66.1906 95.1224Z"
            fill="#CBD7DD"
          />
          <path
            opacity="0.4762"
            d="M66.1906 95.1225C73.2369 96.1291 76.2568 101.162 71.2237 109.215C67.1972 114.248 60.1509 116.262 54.1111 117.268C47.0648 118.275 42.0317 113.242 47.0648 105.189C50.0846 98.1423 59.1442 95.1225 66.1906 95.1225Z"
            fill="#C5D3D9"
          />
          <path
            opacity="0.5238"
            d="M65.1839 96.1291C72.2302 97.1357 75.2501 102.169 70.217 109.215C66.1905 114.248 59.1442 116.262 54.111 116.262C47.0647 117.268 43.0382 112.235 47.0647 104.182C51.0912 98.1423 59.1442 95.1224 65.1839 96.1291Z"
            fill="#C0CED6"
          />
          <path
            opacity="0.5714"
            d="M65.184 96.1291C72.2304 96.1291 75.2502 101.162 70.2171 108.209C66.1906 113.242 60.1509 115.255 54.1112 115.255C48.0714 116.262 43.0383 111.228 48.0714 104.182C51.0913 98.1423 59.1443 95.1224 65.184 96.1291Z"
            fill="#BACAD2"
          />
          <path
            opacity="0.619"
            d="M65.1839 96.1291C72.2302 96.1291 75.2501 101.162 70.217 108.209C66.1905 113.242 60.1508 115.255 55.1177 115.255C49.0779 116.262 45.0514 112.235 49.0779 104.182C52.0978 99.1489 59.1441 96.1291 65.1839 96.1291Z"
            fill="#B4C5CE"
          />
          <path
            opacity="0.6667"
            d="M65.1839 96.1291C71.2236 96.1291 75.2501 100.156 70.217 107.202C66.1905 112.235 60.1508 113.242 55.1177 114.248C49.0779 115.255 45.0514 111.228 49.0779 104.182C52.0978 99.1489 59.1441 96.1291 65.1839 96.1291Z"
            fill="#AEC1CA"
          />
          <path
            opacity="0.7143"
            d="M64.1773 97.1357C70.2171 97.1357 73.2369 101.162 68.2038 107.202C64.1773 112.235 58.1376 113.242 54.1111 114.248C49.078 115.255 45.0515 111.228 49.078 104.182C53.1045 99.1489 59.1442 97.1357 64.1773 97.1357Z"
            fill="#A9BDC7"
          />
          <path
            opacity="0.7619"
            d="M64.1773 97.1357C70.2171 97.1357 73.2369 100.156 68.2038 106.195C65.184 111.228 58.1376 112.235 54.1111 113.242C49.078 114.248 45.0515 110.222 49.078 104.182C53.1045 99.1489 59.1442 97.1357 64.1773 97.1357Z"
            fill="#A3B8C3"
          />
          <path
            opacity="0.8095"
            d="M64.1773 97.1357C69.2104 97.1357 73.2369 100.156 68.2038 106.195C65.1839 110.222 59.1442 112.235 55.1177 113.242C50.0846 114.248 46.0581 111.228 51.0912 104.182C53.1045 99.1489 59.1442 97.1357 64.1773 97.1357Z"
            fill="#9DB4BF"
          />
          <path
            opacity="0.8571"
            d="M64.1773 98.1423C69.2104 98.1423 72.2302 101.162 68.2037 106.195C65.1839 110.222 59.1442 112.235 55.1177 112.235C51.0912 112.235 47.0647 110.222 51.0912 103.175C54.111 99.1489 59.1442 98.1423 64.1773 98.1423Z"
            fill="#97AFBB"
          />
          <path
            opacity="0.9048"
            d="M63.1706 98.1423C68.2037 98.1423 71.2236 100.156 67.1971 105.189C64.1773 109.215 58.1375 111.228 55.1177 111.228C51.0912 112.235 47.0647 109.215 51.0912 103.175C54.111 100.156 59.1442 98.1423 63.1706 98.1423Z"
            fill="#92ABB8"
          />
          <path
            opacity="0.9524"
            d="M63.1707 98.1423C67.1971 98.1423 71.2236 100.156 67.1971 104.182C64.1773 108.209 58.1376 110.222 55.1177 110.222C51.0912 111.228 48.0713 108.209 52.0978 102.169C55.1177 100.156 59.1442 99.1489 63.1707 98.1423Z"
            fill="#8CA6B4"
          />
          <path
            d="M63.1707 99.1489C67.1972 98.1423 70.217 100.156 67.1972 105.189C64.1773 109.215 58.1376 111.228 56.1243 111.228C53.1045 112.235 49.078 110.222 53.1045 104.182C55.1177 100.156 59.1442 99.1489 63.1707 99.1489Z"
            fill="#86A2B0"
          />
          <path
            opacity="0.047619"
            d="M149.74 96.1291C140.681 88.0761 143.7 75.9966 157.793 70.9635C164.84 67.9437 174.906 68.9503 183.965 73.9834C194.032 80.0231 195.038 90.0894 183.965 97.1357C173.899 103.175 158.8 104.182 149.74 96.1291Z"
            fill="#F9FBFB"
          />
          <path
            opacity="0.095238"
            d="M149.74 95.1225C140.681 87.0695 143.7 75.9966 157.793 70.9635C164.84 67.9437 174.906 68.9503 183.965 73.9834C194.032 80.0231 195.038 90.0893 183.965 96.1291C173.899 102.169 158.8 103.175 149.74 95.1225Z"
            fill="#F3F6F7"
          />
          <path
            opacity="0.1429"
            d="M150.747 95.1225C141.687 87.0695 145.714 75.9966 157.793 70.9635C164.839 67.9437 173.899 68.9503 182.959 73.9834C192.018 79.0165 194.031 89.0827 182.959 95.1225C173.899 101.162 159.806 102.169 150.747 95.1225Z"
            fill="#EEF2F4"
          />
          <path
            opacity="0.1905"
            d="M151.753 95.1224C142.694 87.0695 146.72 77.0033 158.8 71.9702C165.846 68.9503 174.906 69.9569 182.959 74.99C192.018 80.0231 193.025 90.0893 182.959 96.1291C172.892 101.162 159.806 102.169 151.753 95.1224Z"
            fill="#E8EDF0"
          />
          <path
            opacity="0.2381"
            d="M151.753 94.1158C142.694 87.0695 146.72 75.9966 158.8 71.9702C165.846 69.9569 174.906 69.9569 182.959 74.99C192.018 80.0231 193.025 89.0827 182.959 95.1225C172.892 100.156 159.806 101.162 151.753 94.1158Z"
            fill="#E2E9EC"
          />
          <path
            opacity="0.2857"
            d="M152.76 94.1158C143.7 87.0695 147.727 77.0033 158.8 72.9768C165.846 70.9635 174.906 71.9701 181.952 75.9966C191.012 80.0231 192.018 89.0827 181.952 95.1224C172.892 99.1489 160.813 100.156 152.76 94.1158Z"
            fill="#DCE4E8"
          />
          <path
            opacity="0.3333"
            d="M152.76 94.1158C143.7 87.0695 147.727 77.0033 158.8 72.9768C166.853 70.9635 174.906 71.9701 181.952 75.9966C191.012 80.0231 192.018 89.0827 181.952 94.1158C172.892 99.1489 160.813 100.156 152.76 94.1158Z"
            fill="#D7E0E5"
          />
          <path
            opacity="0.381"
            d="M153.767 93.1092C144.707 87.0695 148.733 77.0033 159.806 72.9768C166.853 70.9635 174.906 71.9701 181.952 75.9966C190.005 80.0231 191.012 89.0827 180.945 94.1158C172.892 98.1423 161.82 99.1489 153.767 93.1092Z"
            fill="#D1DCE1"
          />
          <path
            opacity="0.4286"
            d="M154.773 93.1092C145.714 87.0695 149.74 77.0033 160.813 73.9834C167.859 71.9702 175.912 72.9768 182.959 77.0033C190.005 81.0297 191.012 89.0827 181.952 94.1158C172.892 98.1423 161.82 98.1423 154.773 93.1092Z"
            fill="#CBD7DD"
          />
          <path
            opacity="0.4762"
            d="M154.773 92.1026C146.72 86.0629 149.74 77.0033 159.806 73.9834C166.853 71.9702 174.906 72.9768 180.945 77.0033C187.992 81.0297 188.998 88.0761 179.939 93.1092C172.892 97.1357 162.826 98.1423 154.773 92.1026Z"
            fill="#C5D3D9"
          />
          <path
            opacity="0.5238"
            d="M155.78 92.1026C147.727 87.0695 150.747 77.0033 160.813 73.9834C167.859 71.9702 175.912 72.9768 181.952 77.0033C188.998 81.0297 190.005 88.0761 180.945 93.1092C172.892 97.1357 162.826 97.1357 155.78 92.1026Z"
            fill="#C0CED6"
          />
          <path
            opacity="0.5714"
            d="M155.78 92.1026C147.727 87.0695 150.747 78.0099 160.813 74.99C167.859 72.9768 174.906 74.99 180.945 78.0099C187.992 82.0364 187.992 88.0761 178.932 93.1092C171.886 96.1291 163.833 96.1291 155.78 92.1026Z"
            fill="#BACAD2"
          />
          <path
            opacity="0.619"
            d="M156.787 91.096C148.734 86.0629 151.753 77.0033 160.813 74.99C167.859 72.9768 174.906 74.99 179.939 77.0033C185.979 80.0231 186.985 87.0695 177.926 91.096C171.886 95.1225 163.833 96.1291 156.787 91.096Z"
            fill="#B4C5CE"
          />
          <path
            opacity="0.6667"
            d="M157.793 91.096C149.74 87.0695 152.76 78.0099 161.82 75.9966C168.866 73.9834 175.912 75.9966 180.945 78.0099C186.985 81.0297 187.992 87.0695 178.932 91.096C171.886 95.1225 164.839 95.1225 157.793 91.096Z"
            fill="#AEC1CA"
          />
          <path
            opacity="0.7143"
            d="M157.793 91.096C149.74 87.0695 152.76 79.0165 161.82 75.9966C168.866 73.9834 175.912 75.9966 179.939 78.0099C185.978 81.0297 186.985 87.0695 177.925 91.096C171.886 94.1158 164.839 94.1158 157.793 91.096Z"
            fill="#A9BDC7"
          />
          <path
            opacity="0.7619"
            d="M158.8 90.0893C150.747 86.0629 153.767 78.0099 161.82 75.9966C168.866 73.9834 174.906 75.9966 179.939 78.0099C184.972 81.0297 185.979 86.0629 177.926 90.0893C171.886 94.1158 164.839 94.1158 158.8 90.0893Z"
            fill="#A3B8C3"
          />
          <path
            opacity="0.8095"
            d="M158.8 90.0893C150.747 86.0629 153.767 79.0165 161.82 77.0033C168.866 75.9966 174.906 77.0033 178.932 79.0165C183.965 81.0298 184.972 87.0695 176.919 90.0893C171.886 93.1092 165.846 93.1092 158.8 90.0893Z"
            fill="#9DB4BF"
          />
          <path
            opacity="0.8571"
            d="M159.806 90.0893C151.753 87.0695 154.773 79.0165 162.826 78.0099C169.873 77.0033 175.912 78.0099 179.939 80.0231C184.972 82.0364 184.972 87.0695 176.919 91.096C171.886 92.1026 165.846 92.1026 159.806 90.0893Z"
            fill="#97AFBB"
          />
          <path
            opacity="0.9048"
            d="M160.813 89.0827C152.76 86.0629 155.78 79.0165 163.833 77.0033C170.879 75.9966 176.919 78.0099 179.939 79.0165C183.965 81.0297 184.972 86.0629 176.919 89.0827C171.886 92.1026 166.853 92.1026 160.813 89.0827Z"
            fill="#92ABB8"
          />
          <path
            opacity="0.9524"
            d="M160.813 89.0827C152.76 86.0629 155.78 79.0165 162.826 78.0099C169.873 77.0033 175.912 79.0165 177.926 80.0231C181.952 82.0364 182.959 86.0629 174.906 89.0827C171.886 91.096 166.853 91.096 160.813 89.0827Z"
            fill="#8CA6B4"
          />
          <path
            d="M161.82 88.0761C154.773 86.0629 156.787 79.0165 163.833 78.0099C170.879 77.0033 175.912 79.0165 178.932 80.0231C182.959 82.0364 183.965 86.0629 175.912 89.0827C170.879 91.096 167.859 90.0893 161.82 88.0761Z"
            fill="#86A2B0"
          />
          <path
            opacity="0.047619"
            d="M147.727 64.9238C134.641 64.9238 129.608 53.851 136.654 40.7649C139.674 33.7185 147.727 27.6788 157.793 25.6655C168.866 23.6523 177.926 32.7119 173.899 44.7914C170.879 56.8708 159.806 64.9238 147.727 64.9238Z"
            fill="#F9FBFB"
          />
          <path
            opacity="0.095238"
            d="M147.727 63.9172C135.647 63.9172 130.614 52.8443 136.654 40.7649C139.674 33.7185 147.727 27.6788 157.793 25.6655C168.866 23.6523 176.919 32.7119 172.892 44.7914C169.873 55.8642 159.806 63.9172 147.727 63.9172Z"
            fill="#F3F6F7"
          />
          <path
            opacity="0.1429"
            d="M148.733 62.9106C136.654 62.9106 131.621 52.8443 137.661 40.7649C141.687 33.7185 148.733 27.6788 157.793 25.6656C168.866 23.6523 175.912 32.7119 172.892 43.7847C169.873 55.8642 159.806 62.9106 148.733 62.9106Z"
            fill="#EEF2F4"
          />
          <path
            opacity="0.1905"
            d="M148.733 62.9106C136.654 63.9172 132.628 52.8444 138.667 40.7649C142.694 33.7185 149.74 28.6854 158.8 26.6722C168.866 24.6589 176.919 32.7119 172.892 44.7914C168.866 54.8576 159.806 61.904 148.733 62.9106Z"
            fill="#E8EDF0"
          />
          <path
            opacity="0.2381"
            d="M148.733 61.9039C137.661 62.9106 132.628 51.8377 138.667 40.7649C142.694 33.7185 149.74 28.6854 158.8 26.6722C168.866 24.6589 175.912 32.7119 171.886 43.7848C168.866 53.851 158.8 60.8973 148.733 61.9039Z"
            fill="#E2E9EC"
          />
          <path
            opacity="0.2857"
            d="M148.733 60.8973C137.661 61.9039 132.628 51.8377 138.667 40.7649C142.694 33.7185 149.74 28.6854 157.793 26.6722C167.859 24.6589 173.899 32.7119 170.879 43.7848C167.859 53.851 158.8 60.8973 148.733 60.8973Z"
            fill="#DCE4E8"
          />
          <path
            opacity="0.3333"
            d="M148.733 60.8973C137.661 61.9039 133.634 51.8377 139.674 41.7715C143.7 35.7318 150.747 30.6986 158.8 28.6854C167.859 26.6722 174.906 33.7185 170.879 44.7914C167.859 52.8443 158.8 59.8907 148.733 60.8973Z"
            fill="#D7E0E5"
          />
          <path
            opacity="0.381"
            d="M148.733 59.8907C138.667 60.8973 134.641 51.8377 139.674 40.7649C143.7 34.7252 149.74 29.692 157.793 27.6788C166.853 25.6656 172.892 32.7119 169.872 43.7847C166.853 52.8443 158.8 58.8841 148.733 59.8907Z"
            fill="#D1DCE1"
          />
          <path
            opacity="0.4286"
            d="M149.74 58.8841C139.674 59.8907 134.641 50.8311 140.681 40.7649C144.707 34.7251 150.747 29.692 158.8 27.6788C166.853 25.6656 173.899 32.7119 169.873 42.7781C166.853 51.8377 158.8 57.8775 149.74 58.8841Z"
            fill="#CBD7DD"
          />
          <path
            opacity="0.4762"
            d="M149.74 58.8841C139.674 60.8973 135.647 50.8311 140.681 41.7715C144.707 35.7318 150.747 30.6987 157.793 29.6921C165.846 27.6788 171.886 34.7252 167.859 43.7848C165.846 51.8377 158.8 56.8708 149.74 58.8841Z"
            fill="#C5D3D9"
          />
          <path
            opacity="0.5238"
            d="M149.74 57.8775C139.674 59.8907 135.647 50.8311 141.687 41.7715C145.714 35.7318 151.753 31.7053 158.8 29.692C166.853 27.6788 171.886 33.7185 168.866 43.7848C165.846 50.8311 158.8 56.8708 149.74 57.8775Z"
            fill="#C0CED6"
          />
          <path
            opacity="0.5714"
            d="M149.74 56.8708C139.674 58.8841 136.654 49.8245 141.687 40.7649C145.714 34.7252 151.753 30.6987 157.793 28.6854C164.839 26.6722 170.879 32.7119 166.853 41.7715C164.839 50.8311 158.8 55.8642 149.74 56.8708Z"
            fill="#BACAD2"
          />
          <path
            opacity="0.619"
            d="M149.74 56.8708C140.681 58.8841 136.654 49.8245 141.687 41.7715C145.714 35.7318 151.753 31.7053 157.793 30.6987C164.839 28.6854 169.873 34.7252 166.853 43.7848C164.839 49.8245 157.793 54.8576 149.74 56.8708Z"
            fill="#B4C5CE"
          />
          <path
            opacity="0.6667"
            d="M150.747 55.8642C141.687 57.8775 138.667 49.8245 143.7 41.7715C147.727 35.7318 153.767 31.7053 159.806 30.6987C165.846 28.6854 170.879 33.7185 167.859 42.7781C163.833 49.8245 157.793 53.851 150.747 55.8642Z"
            fill="#AEC1CA"
          />
          <path
            opacity="0.7143"
            d="M150.747 54.8576C141.687 56.8708 138.667 48.8179 143.7 41.7715C147.727 35.7318 153.767 32.7119 158.8 30.6987C164.839 28.6854 169.872 33.7185 165.846 42.7781C163.833 48.8179 157.793 52.8444 150.747 54.8576Z"
            fill="#A9BDC7"
          />
          <path
            opacity="0.7619"
            d="M150.747 54.8576C142.694 56.8708 138.667 49.8245 143.7 42.7781C147.727 36.7384 153.767 33.7185 158.8 32.7119C164.839 30.6987 168.866 35.7318 165.846 43.7847C162.826 48.8179 157.793 52.8443 150.747 54.8576Z"
            fill="#A3B8C3"
          />
          <path
            opacity="0.8095"
            d="M150.747 53.851C142.694 56.8708 139.674 48.8179 144.707 41.7715C148.733 35.7318 154.773 32.7119 158.8 31.7053C163.833 30.6987 168.866 33.7185 164.839 42.7781C162.826 47.8112 157.793 51.8377 150.747 53.851Z"
            fill="#9DB4BF"
          />
          <path
            opacity="0.8571"
            d="M150.747 52.8443C142.694 55.8642 139.674 47.8112 144.707 41.7715C148.733 36.7384 154.773 33.7185 158.8 31.7053C163.833 30.6987 167.859 33.7185 163.833 41.7715C161.82 47.8112 157.793 50.8311 150.747 52.8443Z"
            fill="#97AFBB"
          />
          <path
            opacity="0.9048"
            d="M151.753 52.8443C143.7 55.8642 141.687 48.8179 145.714 42.7781C149.74 37.745 155.78 34.7251 158.8 33.7185C163.833 32.7119 166.853 35.7318 163.833 42.7781C161.82 46.8046 157.793 49.8245 151.753 52.8443Z"
            fill="#92ABB8"
          />
          <path
            opacity="0.9524"
            d="M151.753 51.8377C144.707 54.8576 141.687 47.8112 145.714 42.7781C149.74 37.745 155.78 34.7251 158.8 33.7185C162.826 32.7119 166.853 35.7318 162.826 42.7781C160.813 46.8046 157.793 48.8179 151.753 51.8377Z"
            fill="#8CA6B4"
          />
          <path
            d="M151.753 50.8311C144.707 53.851 142.694 46.8046 146.72 41.7715C150.747 36.7384 156.786 33.7185 158.8 32.7119C162.826 31.7053 165.846 33.7185 162.826 40.7649C160.813 45.798 157.793 48.8179 151.753 50.8311Z"
            fill="#86A2B0"
          />
          <path
            opacity="0.047619"
            d="M128.601 41.7715C119.542 50.8311 106.455 47.8112 101.422 33.7185C98.4025 26.6722 99.4091 16.606 105.449 7.54636C111.489 -2.51986 126.588 -2.51986 132.628 8.55298C137.661 20.6324 136.654 33.7185 128.601 41.7715Z"
            fill="#F9FBFB"
          />
          <path
            opacity="0.095238"
            d="M127.594 41.7715C119.541 50.8311 106.455 47.8112 101.422 34.7252C98.4023 27.6788 99.409 17.6126 104.442 8.55299C110.482 -1.51323 124.575 -0.506608 130.614 9.55961C136.654 20.6325 135.647 32.7119 127.594 41.7715Z"
            fill="#F3F6F7"
          />
          <path
            opacity="0.1429"
            d="M127.594 40.7649C119.541 49.8245 106.455 46.8046 101.422 33.7185C98.4023 26.6722 99.409 17.6126 104.442 8.55299C110.482 -0.506607 124.575 -0.506607 129.608 9.55961C135.647 20.6324 134.641 32.7119 127.594 40.7649Z"
            fill="#EEF2F4"
          />
          <path
            opacity="0.1905"
            d="M126.588 40.7649C118.535 49.8245 106.455 46.8046 101.422 33.7185C99.4091 26.6722 99.4091 17.6126 104.442 9.55961C110.482 0.500015 124.575 0.500015 129.608 10.5662C135.647 20.6324 133.634 31.7053 126.588 40.7649Z"
            fill="#E8EDF0"
          />
          <path
            opacity="0.2381"
            d="M126.588 39.7582C119.541 48.8178 106.455 45.798 102.429 32.7119C100.416 25.6655 101.422 16.6059 105.449 8.55297C110.482 0.499997 123.568 0.499997 129.608 10.5662C134.641 20.6324 132.627 31.7053 126.588 39.7582Z"
            fill="#E2E9EC"
          />
          <path
            opacity="0.2857"
            d="M125.581 39.7583C118.535 48.8179 106.455 45.798 102.429 33.7185C100.416 25.6656 101.422 17.6126 105.449 9.55961C110.482 1.50663 122.561 1.50663 128.601 11.5729C133.634 20.6324 132.627 31.7053 125.581 39.7583Z"
            fill="#DCE4E8"
          />
          <path
            opacity="0.3333"
            d="M125.581 38.7516C118.535 47.8112 107.462 44.7914 103.436 32.7119C101.422 25.6656 102.429 17.6126 106.455 9.55961C111.488 1.50663 122.561 1.50664 128.601 11.5729C132.628 20.6324 131.621 30.6987 125.581 38.7516Z"
            fill="#D7E0E5"
          />
          <path
            opacity="0.381"
            d="M124.575 37.745C118.535 46.8046 106.455 43.7847 103.436 31.7053C101.422 25.6656 102.429 16.606 106.455 10.5662C111.488 2.51326 122.561 2.51326 127.594 12.5795C131.621 20.6324 130.614 30.6987 124.575 37.745Z"
            fill="#D1DCE1"
          />
          <path
            opacity="0.4286"
            d="M124.575 37.745C118.535 45.798 107.462 42.7781 104.442 32.7119C101.422 25.6655 103.436 16.6059 106.455 10.5662C110.482 3.51986 121.555 2.51324 126.588 12.5795C130.614 20.6324 129.608 29.692 124.575 37.745Z"
            fill="#CBD7DD"
          />
          <path
            opacity="0.4762"
            d="M123.568 36.7384C117.528 44.7914 106.455 41.7715 103.436 31.7053C101.422 24.6589 102.429 16.606 106.455 10.5662C111.488 3.51987 121.555 3.51987 126.588 12.5795C130.614 20.6324 129.608 29.692 123.568 36.7384Z"
            fill="#C5D3D9"
          />
          <path
            opacity="0.5238"
            d="M123.568 36.7384C118.535 44.7914 107.462 41.7715 104.442 31.7053C102.429 24.6589 104.442 16.606 107.462 11.5729C111.488 4.5265 121.555 3.51988 125.581 13.5861C129.608 20.6324 128.601 28.6854 123.568 36.7384Z"
            fill="#C0CED6"
          />
          <path
            opacity="0.5714"
            d="M122.561 35.7318C117.528 43.7848 107.462 40.7649 104.442 30.6987C102.429 23.6523 104.442 16.606 107.462 10.5662C111.488 4.52651 120.548 3.51989 124.575 12.5795C128.601 20.6325 127.594 28.6854 122.561 35.7318Z"
            fill="#BACAD2"
          />
          <path
            opacity="0.619"
            d="M122.561 35.7318C117.528 43.7847 108.469 40.7649 105.449 30.6987C103.436 23.6523 105.449 16.606 108.469 11.5728C111.489 5.53311 120.548 4.52649 124.575 13.5861C127.594 20.6324 126.588 28.6854 122.561 35.7318Z"
            fill="#B4C5CE"
          />
          <path
            opacity="0.6667"
            d="M122.561 34.7251C117.528 42.7781 108.469 39.7582 106.455 30.6987C104.442 23.6523 106.455 16.6059 109.475 11.5728C112.495 5.53311 120.548 5.53311 124.574 13.5861C126.588 20.6324 125.581 27.6788 122.561 34.7251Z"
            fill="#AEC1CA"
          />
          <path
            opacity="0.7143"
            d="M121.555 33.7185C117.528 41.7715 108.469 38.7516 106.455 29.692C104.442 22.6457 106.455 15.5993 109.475 11.5728C112.495 5.53312 119.541 5.53312 123.568 14.5927C125.581 20.6324 125.581 27.6788 121.555 33.7185Z"
            fill="#A9BDC7"
          />
          <path
            opacity="0.7619"
            d="M121.555 33.7185C117.528 41.7715 108.469 38.7516 107.462 30.6987C106.455 23.6523 107.462 17.6126 110.482 12.5795C113.502 7.54636 120.548 6.53974 123.568 15.5993C125.581 20.6324 124.575 26.6722 121.555 33.7185Z"
            fill="#A3B8C3"
          />
          <path
            opacity="0.8095"
            d="M120.548 32.7119C116.522 40.7649 108.469 37.745 107.462 29.692C106.455 22.6457 107.462 16.606 109.475 12.5795C112.495 7.54636 118.535 7.54636 121.555 15.5993C124.575 20.6324 123.568 26.6722 120.548 32.7119Z"
            fill="#9DB4BF"
          />
          <path
            opacity="0.8571"
            d="M120.548 32.7119C117.528 40.7649 109.475 37.745 107.462 29.692C106.455 22.6457 108.469 16.606 109.475 12.5795C111.488 7.54636 117.528 7.54636 120.548 15.5993C123.568 20.6324 122.561 25.6656 120.548 32.7119Z"
            fill="#97AFBB"
          />
          <path
            opacity="0.9048"
            d="M119.541 31.7053C116.522 39.7582 109.475 36.7384 107.462 28.6854C106.455 21.639 108.469 15.5993 109.475 12.5795C111.488 8.55297 116.522 7.54634 119.541 15.5993C122.561 20.6324 122.561 25.6655 119.541 31.7053Z"
            fill="#92ABB8"
          />
          <path
            opacity="0.9524"
            d="M119.541 31.7053C116.522 38.7516 109.475 36.7384 108.469 29.6921C107.462 22.6457 109.475 16.606 110.482 14.5927C112.495 10.5662 117.528 9.55962 119.541 17.6126C121.555 20.6325 121.555 25.6656 119.541 31.7053Z"
            fill="#8CA6B4"
          />
          <path
            d="M118.535 30.6987C116.522 37.745 109.475 34.7252 108.469 28.6854C107.462 21.6391 109.475 16.606 110.482 13.5861C112.495 9.55962 116.522 9.55962 119.541 16.606C121.555 20.6325 120.548 24.6589 118.535 30.6987Z"
            fill="#86A2B0"
          />
          <path
            opacity="0.047619"
            d="M98.4024 57.8774C95.3825 70.9635 83.3031 72.9768 72.2302 62.9106C66.1905 57.8774 62.164 48.8179 62.164 38.7516C62.164 26.6722 71.2236 20.6324 82.2964 27.6788C92.3627 33.7185 100.416 46.8046 98.4024 57.8774Z"
            fill="#F9FBFB"
          />
          <path
            opacity="0.095238"
            d="M97.3958 57.8774C94.3759 69.9569 83.3031 71.9701 72.2302 62.9106C66.1905 57.8774 62.164 48.8178 62.164 38.7516C62.164 27.6788 71.2236 21.6391 81.2898 27.6788C92.3627 33.7185 99.409 46.8046 97.3958 57.8774Z"
            fill="#F3F6F7"
          />
          <path
            opacity="0.1429"
            d="M96.3891 57.8774C94.3759 68.9503 82.2964 70.9635 72.2302 61.9039C66.1905 56.8708 62.164 48.8178 63.1706 38.7516C63.1706 27.6788 71.2236 22.6457 82.2964 28.6854C91.356 34.7251 99.409 46.8046 96.3891 57.8774Z"
            fill="#EEF2F4"
          />
          <path
            opacity="0.1905"
            d="M96.3892 56.8708C94.376 68.9503 82.2965 70.9635 72.2303 61.9039C67.1972 56.8708 63.1707 48.8178 63.1707 38.7516C63.1707 27.6788 71.2237 22.6457 81.2899 28.6854C91.3561 34.7251 98.4025 46.8046 96.3892 56.8708Z"
            fill="#E8EDF0"
          />
          <path
            opacity="0.2381"
            d="M95.3826 56.8708C93.3693 67.9436 82.2965 69.9569 73.2369 61.9039C67.1972 56.8708 63.1707 47.8112 64.1773 38.7516C64.1773 28.6854 72.2303 23.6523 82.2965 29.692C90.3495 35.7318 97.3958 46.8046 95.3826 56.8708Z"
            fill="#E2E9EC"
          />
          <path
            opacity="0.2857"
            d="M95.3825 56.8708C93.3692 67.9437 82.2964 69.9569 73.2368 60.8973C67.1971 55.8642 64.1772 47.8112 64.1772 38.7516C64.1772 29.692 71.2236 23.6523 81.2898 30.6986C90.3494 35.7318 96.3891 45.798 95.3825 56.8708Z"
            fill="#DCE4E8"
          />
          <path
            opacity="0.3333"
            d="M94.3759 55.8642C92.3627 66.937 82.2965 68.9503 73.2369 60.8973C68.2038 55.8642 64.1773 47.8112 65.1839 38.7516C65.1839 29.692 72.2303 24.6589 81.2899 30.6987C89.3428 35.7318 95.3826 45.798 94.3759 55.8642Z"
            fill="#D7E0E5"
          />
          <path
            opacity="0.381"
            d="M93.3693 55.8642C92.3627 66.937 81.2898 67.9437 73.2369 59.8907C68.2038 54.8576 65.1839 46.8046 65.1839 38.7516C65.1839 29.692 72.2303 24.6589 81.2898 30.6987C89.3428 36.7384 95.3825 45.798 93.3693 55.8642Z"
            fill="#D1DCE1"
          />
          <path
            opacity="0.4286"
            d="M93.3693 54.8576C92.3627 64.9238 82.2964 66.937 74.2435 58.8841C69.2104 53.851 66.1905 45.798 66.1905 38.7516C65.1839 30.6987 72.2302 25.6656 81.2898 31.7053C88.3362 36.7384 94.3759 45.798 93.3693 54.8576Z"
            fill="#CBD7DD"
          />
          <path
            opacity="0.4762"
            d="M92.3626 54.8576C91.356 64.9238 81.2898 66.9371 74.2434 58.8841C69.2103 53.851 66.1904 45.798 66.1904 38.7516C66.1904 30.6987 72.2302 26.6722 81.2898 32.7119C88.3361 37.745 93.3692 45.798 92.3626 54.8576Z"
            fill="#C5D3D9"
          />
          <path
            opacity="0.5238"
            d="M92.3626 54.8576C91.356 64.9238 81.2898 65.9304 74.2434 58.8841C69.2103 53.851 66.1904 45.798 66.1904 39.7583C66.1904 31.7053 72.2302 27.6788 80.2831 33.7185C87.3295 37.745 92.3626 45.798 92.3626 54.8576Z"
            fill="#C0CED6"
          />
          <path
            opacity="0.5714"
            d="M91.3561 53.851C91.3561 63.9172 81.2898 64.9238 74.2435 57.8774C69.2104 52.8443 67.1971 45.798 67.1971 39.7582C67.1971 32.7119 73.2369 27.6788 81.2898 33.7185C87.3296 37.745 91.3561 45.798 91.3561 53.851Z"
            fill="#BACAD2"
          />
          <path
            opacity="0.619"
            d="M90.3494 53.851C90.3494 62.9106 81.2898 64.9238 74.2435 57.8774C69.2104 52.8443 67.1971 45.798 67.1971 39.7583C67.1971 32.7119 72.2302 28.6854 80.2832 34.7251C87.3296 38.7516 91.356 45.798 90.3494 53.851Z"
            fill="#B4C5CE"
          />
          <path
            opacity="0.6667"
            d="M90.3495 53.851C90.3495 62.9106 81.2899 64.9238 75.2502 57.8774C70.2171 51.8377 68.2038 44.7914 68.2038 39.7583C68.2038 32.7119 73.2369 29.692 81.2899 34.7251C86.323 38.7516 90.3495 45.798 90.3495 53.851Z"
            fill="#AEC1CA"
          />
          <path
            opacity="0.7143"
            d="M89.3429 52.8443C89.3429 61.9039 80.2833 62.9106 74.2435 56.8708C70.2171 51.8377 68.2038 44.7914 68.2038 39.7583C68.2038 33.7185 73.2369 29.692 80.2833 35.7318C86.323 39.7583 89.3429 45.798 89.3429 52.8443Z"
            fill="#A9BDC7"
          />
          <path
            opacity="0.7619"
            d="M89.3429 52.8444C89.3429 61.9039 81.2899 62.9106 75.2502 56.8708C70.2171 50.8311 68.2038 44.7914 68.2038 39.7583C68.2038 33.7185 72.2303 30.6987 80.2833 35.7318C85.3164 39.7583 88.3363 45.798 89.3429 52.8444Z"
            fill="#A3B8C3"
          />
          <path
            opacity="0.8095"
            d="M88.3361 52.8443C89.3428 61.9039 80.2832 62.9105 75.2501 55.8642C71.2236 50.8311 69.2103 43.7847 69.2103 39.7582C69.2103 33.7185 73.2368 30.6986 80.2832 36.7384C85.3163 39.7582 87.3295 45.798 88.3361 52.8443Z"
            fill="#9DB4BF"
          />
          <path
            opacity="0.8571"
            d="M87.3295 51.8377C88.3361 60.8973 80.2832 61.9039 75.2501 55.8642C71.2236 50.8311 69.2103 43.7847 69.2103 39.7583C69.2103 34.7251 73.2368 31.7053 80.2832 36.7384C84.3097 40.7649 87.3295 45.798 87.3295 51.8377Z"
            fill="#97AFBB"
          />
          <path
            opacity="0.9048"
            d="M87.3296 51.8377C88.3362 59.8907 80.2832 60.8973 75.2501 54.8576C71.2236 49.8245 70.217 43.7847 70.217 39.7583C70.217 34.7251 73.2369 31.7053 80.2832 37.745C84.3097 40.7649 86.323 44.7914 87.3296 51.8377Z"
            fill="#92ABB8"
          />
          <path
            opacity="0.9524"
            d="M86.323 51.8377C87.3296 59.8907 80.2832 60.8973 76.2567 54.8576C72.2303 49.8245 70.217 42.7781 70.217 39.7583C70.217 35.7318 73.2369 32.7119 80.2832 37.745C83.3031 40.7649 85.3163 44.7914 86.323 51.8377Z"
            fill="#8CA6B4"
          />
          <path
            d="M86.323 50.8311C88.3362 58.8841 80.2832 58.8841 76.2567 53.851C72.2303 48.8179 71.2236 42.7781 70.217 39.7583C70.217 35.7318 73.2369 32.7119 79.2766 38.7516C83.3031 41.7715 84.3097 44.7914 86.323 50.8311Z"
            fill="#86A2B0"
          />
          <path
            opacity="0.047619"
            d="M67.1972 145.454C54.1111 146.46 49.078 135.387 55.1177 122.301C58.1376 115.255 65.1839 108.209 76.2567 106.195C87.3296 103.175 97.3958 110.222 94.3759 122.301C90.3495 134.381 79.2766 145.454 67.1972 145.454Z"
            fill="#F9FBFB"
          />
          <path
            opacity="0.095238"
            d="M67.1972 145.454C55.1177 146.46 49.078 135.387 55.1177 122.301C58.1376 115.255 65.1839 109.215 75.2502 106.195C86.323 103.175 95.3826 110.222 92.3627 122.301C90.3495 133.374 79.2766 144.447 67.1972 145.454Z"
            fill="#F3F6F7"
          />
          <path
            opacity="0.1429"
            d="M68.2038 144.447C56.1244 145.454 51.0913 135.387 56.1244 122.301C59.1442 115.255 66.1906 109.215 76.2568 106.195C87.3296 103.175 96.3892 110.222 93.3694 122.301C89.3429 133.374 79.2767 143.44 68.2038 144.447Z"
            fill="#EEF2F4"
          />
          <path
            opacity="0.1905"
            d="M68.2037 143.44C56.1243 144.447 51.0912 134.381 57.1309 122.301C60.1508 115.255 67.1971 109.215 76.2567 107.202C86.3229 104.182 95.3825 111.228 92.3627 122.301C89.3428 133.374 79.2766 142.434 68.2037 143.44Z"
            fill="#E8EDF0"
          />
          <path
            opacity="0.2381"
            d="M68.2037 143.44C57.1308 144.447 51.0911 134.381 57.1309 123.308C60.1507 116.262 67.1971 110.222 76.2567 108.209C86.3229 105.189 94.3759 111.228 91.356 123.308C88.3361 132.367 78.2699 141.427 68.2037 143.44Z"
            fill="#E2E9EC"
          />
          <path
            opacity="0.2857"
            d="M68.2037 142.434C57.1309 143.44 52.0978 134.381 57.1309 122.301C60.1507 115.255 67.1971 110.222 75.2501 107.202C84.3097 104.182 93.3693 110.222 89.3428 121.295C87.3295 132.367 78.2699 141.427 68.2037 142.434Z"
            fill="#DCE4E8"
          />
          <path
            opacity="0.3333"
            d="M68.2038 141.427C57.1309 143.44 52.0978 133.374 58.1375 122.301C61.1574 115.255 68.2038 110.222 76.2567 108.209C85.3163 105.189 93.3693 111.228 90.3494 122.301C87.3296 132.367 78.27 140.42 68.2038 141.427Z"
            fill="#D7E0E5"
          />
          <path
            opacity="0.381"
            d="M68.2038 141.427C57.131 143.44 53.1045 133.374 58.1376 123.308C61.1575 116.262 68.2038 111.228 76.2568 109.215C85.3164 107.202 92.3627 112.235 89.3429 123.308C86.323 131.361 78.27 139.414 68.2038 141.427Z"
            fill="#D1DCE1"
          />
          <path
            opacity="0.4286"
            d="M69.2104 140.42C59.1441 142.434 54.111 133.374 59.1441 123.308C62.164 117.268 69.2104 112.235 76.2567 109.215C84.3097 107.202 91.356 112.235 88.3362 122.301C86.3229 131.361 78.27 138.407 69.2104 140.42Z"
            fill="#CBD7DD"
          />
          <path
            opacity="0.4762"
            d="M69.2104 139.414C59.1442 141.427 55.1177 132.367 60.1508 122.301C63.1707 116.262 70.217 111.228 77.2634 109.215C85.3164 107.202 92.3627 112.235 89.3429 122.301C85.3164 130.354 78.27 137.401 69.2104 139.414Z"
            fill="#C5D3D9"
          />
          <path
            opacity="0.5238"
            d="M69.2104 139.414C59.1442 141.427 55.1177 132.367 60.1508 123.308C63.1707 117.268 70.217 112.235 76.2568 110.222C84.3097 108.209 90.3495 112.235 87.3296 122.301C85.3164 130.354 77.2634 137.401 69.2104 139.414Z"
            fill="#C0CED6"
          />
          <path
            opacity="0.5714"
            d="M69.2104 138.407C60.1508 140.42 55.1177 132.367 60.1508 123.308C63.1707 117.268 70.2171 112.235 76.2568 111.228C83.3031 109.215 89.3429 113.242 86.323 123.308C84.3098 130.354 77.2634 136.394 69.2104 138.407Z"
            fill="#BACAD2"
          />
          <path
            opacity="0.619"
            d="M69.2104 137.401C60.1508 140.42 56.1244 131.361 61.1575 123.308C64.1773 117.268 71.2237 113.242 76.2568 111.228C83.3031 109.215 89.3429 113.242 86.323 122.301C83.3031 129.348 77.2634 135.387 69.2104 137.401Z"
            fill="#B4C5CE"
          />
          <path
            opacity="0.6667"
            d="M69.2105 136.394C61.1575 139.414 57.131 131.361 61.1575 123.308C65.184 117.268 71.2237 113.242 76.2568 111.228C82.2966 109.215 88.3363 113.242 85.3164 122.301C83.3032 129.348 77.2635 134.381 69.2105 136.394Z"
            fill="#AEC1CA"
          />
          <path
            opacity="0.7143"
            d="M70.217 136.394C61.1574 139.414 57.1309 131.361 62.164 123.308C66.1905 117.268 72.2302 113.242 77.2633 112.235C83.3031 110.222 88.3362 114.248 85.3163 123.308C82.2964 129.348 77.2633 133.374 70.217 136.394Z"
            fill="#A9BDC7"
          />
          <path
            opacity="0.7619"
            d="M70.217 135.387C62.164 138.407 58.1375 130.354 63.1706 123.308C67.1971 117.268 73.2368 113.242 77.2633 112.235C83.303 110.222 88.3361 114.248 84.3097 122.301C82.2964 128.341 77.2633 133.374 70.217 135.387Z"
            fill="#A3B8C3"
          />
          <path
            opacity="0.8095"
            d="M70.217 134.381C62.1641 137.401 59.1442 129.348 63.1707 123.308C67.1972 117.268 72.2303 114.248 77.2634 112.235C82.2965 110.222 87.3296 113.242 84.3097 122.301C81.2899 128.341 76.2568 132.367 70.217 134.381Z"
            fill="#9DB4BF"
          />
          <path
            opacity="0.8571"
            d="M70.217 134.381C62.1641 137.401 59.1442 130.354 63.1707 123.308C67.1972 117.268 72.2303 114.248 76.2568 113.242C81.2899 111.228 86.323 114.248 83.3031 122.301C80.2833 127.334 76.2568 131.361 70.217 134.381Z"
            fill="#97AFBB"
          />
          <path
            opacity="0.9048"
            d="M70.217 133.374C63.1706 136.394 59.1441 129.348 64.1772 123.308C68.2037 117.268 73.2368 114.248 77.2633 113.242C81.2898 111.228 86.3229 114.248 82.2964 122.301C80.2832 127.334 76.2567 130.354 70.217 133.374Z"
            fill="#92ABB8"
          />
          <path
            opacity="0.9524"
            d="M70.217 132.367C63.1707 136.394 60.1508 129.348 64.1773 123.308C68.2038 118.275 73.2369 115.255 76.2568 113.242C81.2899 112.235 85.3163 115.255 81.2899 122.301C79.2766 127.334 76.2568 130.354 70.217 132.367Z"
            fill="#8CA6B4"
          />
          <path
            d="M70.217 132.367C63.1707 136.394 60.1508 129.348 64.1773 124.314C68.2038 119.281 73.2369 116.262 76.2567 115.255C80.2832 114.248 83.3031 116.262 80.2832 123.308C79.2766 126.328 76.2568 129.348 70.217 132.367Z"
            fill="#86A2B0"
          />
          <path
            opacity="0.047619"
            d="M40.0184 99.149C28.9456 93.1092 29.9522 81.0298 42.0317 72.9768C48.0714 68.9503 58.1376 66.9371 68.2039 69.9569C79.2767 72.9768 83.3032 83.043 74.2436 92.1026C65.184 100.156 50.0847 105.189 40.0184 99.149Z"
            fill="#F9FBFB"
          />
          <path
            opacity="0.095238"
            d="M40.0184 99.1489C28.9456 93.1092 29.9522 81.0298 42.0317 72.9768C48.0714 68.9503 58.1376 66.9371 68.2039 69.9569C79.2767 72.9768 82.2966 83.043 73.237 91.096C64.1774 100.156 50.0847 104.182 40.0184 99.1489Z"
            fill="#F3F6F7"
          />
          <path
            opacity="0.1429"
            d="M41.025 98.1423C29.9522 93.1092 30.9588 81.0298 42.0317 73.9834C49.078 68.9503 58.1376 67.9437 67.1972 70.9635C78.27 73.9834 81.2899 83.043 72.2303 91.096C64.1773 99.1489 51.0913 103.175 41.025 98.1423Z"
            fill="#EEF2F4"
          />
          <path
            opacity="0.1905"
            d="M41.0251 98.1423C30.9588 93.1092 31.9655 81.0297 43.0383 73.9834C49.078 69.9569 58.1376 67.9437 67.1972 70.9635C77.2634 73.9834 80.2833 83.043 72.2303 91.096C64.1774 99.1489 51.0913 103.175 41.0251 98.1423Z"
            fill="#E8EDF0"
          />
          <path
            opacity="0.2381"
            d="M42.0316 97.1357C30.9587 93.1092 31.9654 81.0298 43.0382 73.9834C49.0779 69.9569 58.1375 68.9503 67.1971 70.9635C77.2633 73.9834 80.2832 83.043 71.2236 91.096C64.1773 98.1423 51.0912 102.169 42.0316 97.1357Z"
            fill="#E2E9EC"
          />
          <path
            opacity="0.2857"
            d="M42.0316 97.1357C31.9653 92.1026 32.972 81.0298 43.0382 74.99C50.0845 70.9635 58.1375 69.9569 67.1971 71.9702C76.2567 74.99 79.2766 83.043 71.2236 91.096C63.1706 98.1423 52.0978 101.162 42.0316 97.1357Z"
            fill="#DCE4E8"
          />
          <path
            opacity="0.3333"
            d="M43.0382 96.1291C32.972 92.1026 33.9787 81.0298 44.0449 74.99C50.0846 70.9635 59.1442 69.9569 67.1972 71.9702C76.2568 74.99 79.2766 83.043 71.2237 90.0893C63.1707 97.1357 52.0978 100.156 43.0382 96.1291Z"
            fill="#D7E0E5"
          />
          <path
            opacity="0.381"
            d="M43.0382 96.1291C32.972 92.1026 33.9787 81.0298 44.0449 74.99C51.0912 70.9635 59.1442 70.9635 66.1905 72.9768C75.2501 74.99 78.27 83.043 69.2104 90.0893C63.1707 96.1291 52.0978 100.156 43.0382 96.1291Z"
            fill="#D1DCE1"
          />
          <path
            opacity="0.4286"
            d="M44.0449 95.1225C33.9787 91.096 34.9853 81.0298 45.0516 74.99C51.0913 71.9702 59.1443 70.9635 66.1906 72.9768C74.2436 74.99 77.2634 83.043 69.2105 90.0893C62.1641 96.1291 52.0979 99.1489 44.0449 95.1225Z"
            fill="#CBD7DD"
          />
          <path
            opacity="0.4762"
            d="M44.0448 95.1224C34.9852 91.096 35.9919 81.0297 45.0514 75.9966C51.0912 71.9702 59.1442 71.9702 66.1905 73.9834C74.2435 75.9966 77.2633 83.043 69.2104 90.0893C62.164 95.1224 53.1044 98.1423 44.0448 95.1224Z"
            fill="#C5D3D9"
          />
          <path
            opacity="0.5238"
            d="M45.0514 94.1158C34.9852 91.096 35.9918 81.0297 45.0514 75.9966C51.0912 71.9702 59.1441 71.9702 66.1905 73.9834C74.2435 75.9966 76.2567 83.043 68.2037 89.0827C62.164 95.1225 53.1044 97.1357 45.0514 94.1158Z"
            fill="#C0CED6"
          />
          <path
            opacity="0.5714"
            d="M45.0515 94.1158C35.9919 91.096 36.9985 81.0297 46.0581 77.0033C52.0979 73.9834 60.1508 72.9768 66.1906 74.99C73.2369 77.0033 76.2568 83.043 68.2038 90.0893C62.1641 94.1158 53.1045 97.1357 45.0515 94.1158Z"
            fill="#BACAD2"
          />
          <path
            opacity="0.619"
            d="M46.0581 93.1092C36.9985 91.096 38.0051 81.0297 46.0581 77.0033C52.0978 73.9834 60.1508 72.9768 65.1839 74.99C72.2302 77.0033 74.2435 83.043 67.1971 89.0827C61.1574 94.1158 54.111 96.1291 46.0581 93.1092Z"
            fill="#B4C5CE"
          />
          <path
            opacity="0.6667"
            d="M46.058 93.1092C36.9984 91.096 38.0051 82.0364 47.0647 77.0033C53.1044 73.9834 60.1507 73.9834 66.1905 74.99C72.2302 77.0033 75.2501 83.043 67.1971 89.0827C61.1574 93.1092 54.111 95.1225 46.058 93.1092Z"
            fill="#AEC1CA"
          />
          <path
            opacity="0.7143"
            d="M47.0647 92.1026C38.0051 90.0894 39.0117 81.0298 47.0647 77.0033C53.1045 73.9834 60.1508 73.9834 65.1839 74.99C71.2236 77.0033 74.2435 83.043 66.1905 88.0761C61.1574 93.1092 54.1111 94.1158 47.0647 92.1026Z"
            fill="#A9BDC7"
          />
          <path
            opacity="0.7619"
            d="M47.0647 92.1026C38.0051 90.0893 39.0117 82.0364 47.0647 78.0099C53.1045 74.99 60.1508 74.99 65.1839 75.9966C71.2236 77.0033 73.2369 83.043 66.1905 88.0761C61.1574 92.1026 54.1111 94.1158 47.0647 92.1026Z"
            fill="#A3B8C3"
          />
          <path
            opacity="0.8095"
            d="M48.0714 92.1026C40.0184 90.0893 41.025 82.0364 48.0714 79.0165C54.1111 74.99 61.1574 74.99 65.1839 75.9966C70.217 77.0033 72.2303 82.0364 65.1839 88.0761C60.1508 92.1026 55.1177 93.1092 48.0714 92.1026Z"
            fill="#9DB4BF"
          />
          <path
            opacity="0.8571"
            d="M48.0714 91.096C40.0184 90.0893 41.025 82.0364 48.0714 78.0099C54.1111 75.9966 61.1574 75.9966 65.1839 77.0033C70.217 78.0099 72.2303 83.043 65.1839 88.0761C60.1508 91.096 55.1177 92.1026 48.0714 91.096Z"
            fill="#97AFBB"
          />
          <path
            opacity="0.9048"
            d="M49.0779 91.096C41.025 90.0893 42.0316 82.0364 48.0713 79.0165C55.1177 75.9966 61.1574 75.9966 65.1839 77.0033C70.217 78.0099 72.2302 82.0364 65.1839 87.0695C60.1508 90.0894 55.1177 91.096 49.0779 91.096Z"
            fill="#92ABB8"
          />
          <path
            opacity="0.9524"
            d="M49.078 90.0893C41.0251 89.0827 42.0317 82.0364 49.078 79.0165C55.1178 75.9966 61.1575 77.0033 64.1774 77.0033C68.2038 78.0099 70.2171 82.0364 63.1707 87.0695C60.1509 90.0893 55.1178 91.096 49.078 90.0893Z"
            fill="#8CA6B4"
          />
          <path
            d="M50.0846 90.0893C42.0316 90.0893 43.0382 82.0364 50.0846 80.0231C55.1177 77.0033 61.1574 77.0033 64.1773 78.0099C68.2038 79.0165 70.217 83.043 63.1707 87.0695C60.1508 89.0827 56.1243 90.0893 50.0846 90.0893Z"
            fill="#86A2B0"
          />
          <path
            opacity="0.047619"
            d="M133.634 124.314C131.621 112.235 141.687 105.189 155.78 109.215C162.826 111.228 170.879 118.275 173.899 128.341C177.925 139.414 172.892 148.473 159.806 146.46C147.727 145.454 135.647 136.394 133.634 124.314Z"
            fill="#F9FBFB"
          />
          <path
            opacity="0.095238"
            d="M133.634 124.314C131.621 112.235 141.687 105.189 154.773 110.222C161.82 112.235 168.866 119.281 172.892 128.341C176.919 139.414 171.886 147.467 159.806 145.454C147.727 144.447 135.647 136.394 133.634 124.314Z"
            fill="#F3F6F7"
          />
          <path
            opacity="0.1429"
            d="M134.641 124.314C132.628 112.235 142.694 105.189 155.78 110.222C162.826 112.235 169.873 119.281 172.892 128.341C176.919 138.407 171.886 146.46 159.806 145.454C148.734 143.44 136.654 135.387 134.641 124.314Z"
            fill="#EEF2F4"
          />
          <path
            opacity="0.1905"
            d="M134.641 124.314C132.628 112.235 141.687 106.195 154.773 110.222C161.82 112.235 168.866 118.275 171.886 128.341C175.912 138.407 170.879 146.46 158.8 144.447C148.734 143.44 137.661 135.387 134.641 124.314Z"
            fill="#E8EDF0"
          />
          <path
            opacity="0.2381"
            d="M135.647 124.314C132.628 113.242 142.694 106.195 154.773 110.222C161.82 112.235 167.859 118.275 171.886 127.334C174.906 137.401 170.879 144.447 159.806 142.434C148.733 142.434 137.661 135.387 135.647 124.314Z"
            fill="#E2E9EC"
          />
          <path
            opacity="0.2857"
            d="M135.647 124.314C132.628 113.242 142.694 107.202 154.773 111.228C161.82 114.248 167.859 119.281 170.879 128.341C173.899 137.401 169.873 144.447 158.8 143.44C148.733 141.427 138.667 134.381 135.647 124.314Z"
            fill="#DCE4E8"
          />
          <path
            opacity="0.3333"
            d="M136.654 124.314C133.634 113.242 143.7 107.202 154.773 111.228C161.82 114.248 167.859 119.281 170.879 128.341C173.899 137.401 170.879 144.447 158.8 142.434C149.74 141.427 139.674 134.381 136.654 124.314Z"
            fill="#D7E0E5"
          />
          <path
            opacity="0.381"
            d="M137.661 124.314C134.641 114.248 143.7 107.202 154.773 111.228C161.82 114.248 166.853 119.281 169.872 127.334C172.892 135.387 169.872 142.434 158.8 140.42C149.74 140.42 139.674 134.381 137.661 124.314Z"
            fill="#D1DCE1"
          />
          <path
            opacity="0.4286"
            d="M137.661 125.321C134.641 115.255 143.7 109.215 154.773 113.242C161.82 116.262 166.853 121.295 169.872 129.348C172.892 137.401 169.872 143.44 158.8 142.434C149.74 140.42 140.68 133.374 137.661 125.321Z"
            fill="#CBD7DD"
          />
          <path
            opacity="0.4762"
            d="M138.667 125.321C135.647 115.255 144.707 109.215 154.773 113.242C161.82 116.262 166.853 121.295 168.866 128.341C171.886 136.394 168.866 142.434 158.8 140.42C149.74 139.414 141.687 133.374 138.667 125.321Z"
            fill="#C5D3D9"
          />
          <path
            opacity="0.5238"
            d="M138.667 125.321C135.647 116.262 143.7 109.215 153.767 113.242C160.813 116.262 165.846 121.295 167.859 128.341C169.873 135.387 167.859 141.427 157.793 139.414C149.74 138.407 141.687 133.374 138.667 125.321Z"
            fill="#C0CED6"
          />
          <path
            opacity="0.5714"
            d="M139.674 125.321C136.654 116.262 144.707 110.222 154.773 114.248C161.82 117.268 165.846 122.301 167.859 129.348C169.873 136.394 167.859 141.427 157.793 140.42C150.747 138.407 142.694 133.374 139.674 125.321Z"
            fill="#BACAD2"
          />
          <path
            opacity="0.619"
            d="M140.68 125.321C137.661 116.262 145.714 110.222 154.773 114.248C160.813 117.268 165.846 122.301 167.859 128.341C169.872 135.387 168.866 140.42 158.8 138.407C150.747 137.401 142.694 132.367 140.68 125.321Z"
            fill="#B4C5CE"
          />
          <path
            opacity="0.6667"
            d="M140.68 125.321C136.654 116.262 145.714 110.222 153.767 114.248C159.806 117.268 164.839 122.301 166.853 128.341C168.866 134.381 167.859 139.414 157.793 138.407C150.747 136.394 143.7 132.367 140.68 125.321Z"
            fill="#AEC1CA"
          />
          <path
            opacity="0.7143"
            d="M141.687 125.321C137.661 117.268 145.714 111.228 154.773 115.255C160.813 118.275 164.839 123.308 166.853 129.348C168.866 135.387 167.859 139.414 158.8 138.407C150.747 136.394 144.707 132.367 141.687 125.321Z"
            fill="#A9BDC7"
          />
          <path
            opacity="0.7619"
            d="M141.687 125.321C137.661 117.268 145.714 111.228 153.767 115.255C159.806 118.275 163.833 123.308 165.846 128.341C167.859 134.381 166.853 138.407 157.793 136.394C151.753 135.387 144.707 131.361 141.687 125.321Z"
            fill="#A3B8C3"
          />
          <path
            opacity="0.8095"
            d="M142.694 125.321C138.667 117.268 146.72 112.235 153.767 115.255C159.806 118.275 163.833 123.308 164.839 128.341C165.846 133.374 165.846 137.401 156.786 136.394C151.753 134.381 145.714 131.361 142.694 125.321Z"
            fill="#9DB4BF"
          />
          <path
            opacity="0.8571"
            d="M142.694 125.321C138.667 118.275 146.72 112.235 152.76 116.262C158.8 119.281 162.826 123.308 163.833 128.341C164.839 133.374 164.839 136.394 156.786 135.387C151.753 134.381 146.72 131.361 142.694 125.321Z"
            fill="#97AFBB"
          />
          <path
            opacity="0.9048"
            d="M143.7 125.321C139.674 118.275 146.72 112.235 153.767 116.262C159.806 119.281 162.826 123.308 163.833 128.341C164.839 133.374 164.839 136.394 156.786 134.381C151.753 133.374 146.72 130.354 143.7 125.321Z"
            fill="#92ABB8"
          />
          <path
            opacity="0.9524"
            d="M144.707 125.321C140.68 118.275 147.727 113.242 153.767 116.262C159.806 119.281 162.826 123.308 163.833 128.341C164.839 132.367 165.846 135.387 156.786 134.381C152.76 133.374 147.727 130.354 144.707 125.321Z"
            fill="#8CA6B4"
          />
          <path
            d="M144.707 125.321C140.68 119.281 147.727 113.242 152.76 117.268C158.8 120.288 161.82 124.314 161.82 128.341C162.826 132.367 163.833 134.381 155.78 133.374C152.76 132.367 148.733 130.354 144.707 125.321Z"
            fill="#86A2B0"
          />
          <path
            opacity="0.047619"
            d="M125.581 122.301C116.522 113.242 105.449 117.268 100.416 131.361C98.4024 138.407 99.409 148.473 105.449 157.533C111.488 167.599 122.561 167.599 128.601 156.526C133.634 146.46 133.634 131.361 125.581 122.301Z"
            fill="#F9FBFB"
          />
          <path
            opacity="0.095238"
            d="M124.574 123.308C115.515 114.248 104.442 118.275 100.416 132.367C98.4023 139.414 99.4089 149.48 104.442 157.533C110.482 166.593 120.548 167.599 126.588 156.526C132.627 146.46 132.627 131.361 124.574 123.308Z"
            fill="#F3F6F7"
          />
          <path
            opacity="0.1429"
            d="M124.574 123.308C116.521 114.248 105.449 118.275 100.416 131.361C98.4023 138.407 99.4089 147.467 104.442 156.526C110.482 165.586 119.541 166.593 125.581 155.52C131.621 146.46 132.627 131.361 124.574 123.308Z"
            fill="#EEF2F4"
          />
          <path
            opacity="0.1905"
            d="M124.575 124.314C116.522 115.255 105.449 119.281 101.422 132.367C99.409 139.414 100.416 148.473 105.449 156.526C111.488 165.586 120.548 166.593 125.581 155.52C131.621 145.454 131.621 132.367 124.575 124.314Z"
            fill="#E8EDF0"
          />
          <path
            opacity="0.2381"
            d="M123.568 124.314C115.515 115.255 104.442 119.281 101.422 132.367C99.409 139.414 100.416 148.473 105.449 156.526C111.488 164.579 119.541 165.586 125.581 155.52C130.614 145.454 130.614 132.367 123.568 124.314Z"
            fill="#E2E9EC"
          />
          <path
            opacity="0.2857"
            d="M123.568 125.321C116.522 116.262 105.449 120.288 101.422 132.367C99.409 139.414 100.416 147.467 105.449 155.52C111.488 163.573 119.541 164.579 124.575 154.513C129.608 145.454 130.614 133.374 123.568 125.321Z"
            fill="#DCE4E8"
          />
          <path
            opacity="0.3333"
            d="M123.568 125.321C116.522 117.268 105.449 120.288 102.429 132.367C100.416 139.414 101.422 147.467 106.455 154.513C111.489 162.566 119.541 163.573 124.575 153.507C129.608 145.454 129.608 133.374 123.568 125.321Z"
            fill="#D7E0E5"
          />
          <path
            opacity="0.381"
            d="M123.568 126.328C116.522 118.275 106.455 121.295 103.435 133.374C101.422 140.42 102.429 148.473 107.462 155.52C112.495 162.566 119.541 164.579 124.575 154.513C128.601 145.454 129.608 133.374 123.568 126.328Z"
            fill="#D1DCE1"
          />
          <path
            opacity="0.4286"
            d="M122.561 126.328C116.522 118.275 105.449 121.295 102.429 132.367C100.416 139.414 101.422 147.467 106.455 153.507C111.489 160.553 118.535 161.559 123.568 152.5C128.601 145.454 128.601 134.381 122.561 126.328Z"
            fill="#CBD7DD"
          />
          <path
            opacity="0.4762"
            d="M122.561 127.334C116.522 119.281 106.455 122.301 103.435 133.374C101.422 140.42 103.435 147.467 107.462 154.513C112.495 161.559 118.535 162.566 123.568 153.507C127.594 144.447 127.594 134.381 122.561 127.334Z"
            fill="#C5D3D9"
          />
          <path
            opacity="0.5238"
            d="M122.561 127.334C116.522 119.281 106.455 122.301 104.442 133.374C102.429 140.42 104.442 147.467 108.469 153.507C113.502 159.546 118.535 161.559 123.568 152.5C126.588 144.447 127.594 134.381 122.561 127.334Z"
            fill="#C0CED6"
          />
          <path
            opacity="0.5714"
            d="M121.555 128.341C116.522 120.288 106.455 123.308 103.435 133.374C101.422 140.42 103.435 147.467 107.462 152.5C111.488 158.54 117.528 160.553 121.555 151.493C126.588 144.447 126.588 135.387 121.555 128.341Z"
            fill="#BACAD2"
          />
          <path
            opacity="0.619"
            d="M121.555 128.341C116.522 120.288 106.455 123.308 104.442 133.374C103.435 140.42 104.442 146.46 108.469 152.5C112.495 158.54 117.528 159.546 122.561 150.487C125.581 144.447 125.581 135.387 121.555 128.341Z"
            fill="#B4C5CE"
          />
          <path
            opacity="0.6667"
            d="M121.555 129.348C116.522 121.295 106.455 124.314 105.449 133.374C104.442 140.42 105.449 146.46 109.475 151.493C113.502 156.526 117.528 158.54 122.561 149.48C124.575 144.447 125.581 135.387 121.555 129.348Z"
            fill="#AEC1CA"
          />
          <path
            opacity="0.7143"
            d="M120.548 129.348C115.515 121.295 106.455 124.314 104.442 133.374C103.435 140.42 104.442 146.46 108.469 151.493C112.495 156.526 116.522 158.54 120.548 149.48C124.575 144.447 124.575 136.394 120.548 129.348Z"
            fill="#A9BDC7"
          />
          <path
            opacity="0.7619"
            d="M120.548 130.354C116.522 122.301 106.455 125.321 105.449 134.381C104.442 141.427 105.449 147.467 109.475 151.493C113.502 156.526 116.522 157.533 120.548 149.48C123.568 143.44 123.568 136.394 120.548 130.354Z"
            fill="#A3B8C3"
          />
          <path
            opacity="0.8095"
            d="M120.548 130.354C116.521 122.301 107.462 125.321 106.455 133.374C105.449 140.42 106.455 145.454 110.482 150.487C113.502 154.513 117.528 156.526 121.555 148.473C122.561 143.44 123.568 136.394 120.548 130.354Z"
            fill="#9DB4BF"
          />
          <path
            opacity="0.8571"
            d="M119.541 131.361C115.515 123.308 106.455 126.328 105.449 134.381C104.442 141.427 105.449 146.46 109.475 150.487C112.495 154.513 115.515 156.526 119.541 148.473C122.561 143.44 122.561 137.401 119.541 131.361Z"
            fill="#97AFBB"
          />
          <path
            opacity="0.9048"
            d="M119.541 131.361C116.522 124.314 107.462 126.328 106.455 134.381C105.449 141.427 107.462 146.46 110.482 149.48C113.502 153.507 115.515 155.52 119.541 147.467C121.555 143.44 122.561 137.401 119.541 131.361Z"
            fill="#92ABB8"
          />
          <path
            opacity="0.9524"
            d="M119.541 132.367C116.522 125.321 107.462 127.334 107.462 134.381C106.455 141.427 108.469 146.46 111.488 149.48C114.508 152.5 116.522 154.513 119.541 147.467C120.548 143.44 121.555 137.401 119.541 132.367Z"
            fill="#8CA6B4"
          />
          <path
            d="M118.535 132.367C115.515 125.321 107.462 127.334 106.455 134.381C105.449 141.427 107.462 145.454 110.482 148.473C113.502 151.493 114.508 153.507 118.535 146.46C120.548 142.434 120.548 138.407 118.535 132.367Z"
            fill="#86A2B0"
          />
        </g>
        <path
          d="M119.541 21.6391C119.541 30.6987 110.482 38.7516 110.482 38.7516C110.482 38.7516 102.429 30.6987 102.429 21.6391C102.429 12.5795 111.488 4.52649 111.488 4.52649C111.488 4.52649 119.541 12.5795 119.541 21.6391Z"
          fill="#FFE3AB"
        />
        <path
          d="M119.542 138.407C119.542 147.467 110.482 155.52 110.482 155.52C110.482 155.52 101.422 148.473 101.422 138.407C101.422 129.348 110.482 121.295 110.482 121.295C110.482 121.295 119.542 129.348 119.542 138.407Z"
          fill="#FFE3AB"
        />
        <path
          d="M52.0978 71.9701C61.1574 71.9701 69.2104 81.0297 69.2104 81.0297C69.2104 81.0297 61.1574 89.0827 52.0978 89.0827C43.0382 89.0827 34.9853 80.0231 34.9853 80.0231C34.9853 80.0231 43.0382 71.9701 52.0978 71.9701Z"
          fill="#FFE3AB"
        />
        <path
          d="M169.873 71.9701C178.932 71.9701 186.985 81.0297 186.985 81.0297C186.985 81.0297 179.939 90.0893 169.873 90.0893C160.813 90.0893 152.76 81.0297 152.76 81.0297C152.76 81.0297 159.806 71.9701 169.873 71.9701Z"
          fill="#FFE3AB"
        />
        <path
          d="M63.1707 115.255C70.217 109.215 81.2898 109.215 81.2898 109.215C81.2898 109.215 82.2965 120.288 75.2501 127.334C68.2038 134.381 57.1309 133.374 57.1309 133.374C57.1309 133.374 57.1309 122.301 63.1707 115.255Z"
          fill="#FFE3AB"
        />
        <path
          d="M145.714 32.7119C152.76 25.6656 163.833 26.6722 163.833 26.6722C163.833 26.6722 164.839 37.745 157.793 44.7914C151.753 50.8311 140.68 50.8311 140.68 50.8311C140.68 50.8311 139.674 38.7516 145.714 32.7119Z"
          fill="#FFE3AB"
        />
        <path
          d="M145.714 127.334C138.667 120.288 139.674 109.215 139.674 109.215C139.674 109.215 150.747 108.209 157.793 115.255C164.84 122.301 163.833 133.374 163.833 133.374C163.833 133.374 152.76 134.381 145.714 127.334Z"
          fill="#FFE3AB"
        />
        <path
          d="M63.1707 44.7914C57.1309 37.745 57.1309 26.6722 57.1309 26.6722C57.1309 26.6722 68.2038 25.6656 75.2501 32.7119C82.2965 38.7516 81.2898 50.8311 81.2898 50.8311C81.2898 50.8311 70.217 50.8311 63.1707 44.7914Z"
          fill="#FFE3AB"
        />
        <path
          d="M162.826 109.215C155.78 106.195 152.76 98.1423 152.76 98.1423C152.76 98.1423 160.813 94.1158 167.859 97.1357C174.906 100.156 177.926 108.209 177.926 108.209C177.926 108.209 168.866 111.228 162.826 109.215Z"
          fill="#FFE3AB"
        />
        <path
          d="M54.111 63.9172C47.0647 60.8973 44.0448 52.8443 44.0448 52.8443C44.0448 52.8443 52.0978 48.8179 59.1441 50.8311C66.1905 53.851 69.2103 61.9039 69.2103 61.9039C69.2103 61.9039 61.1574 66.9371 54.111 63.9172Z"
          fill="#FFE3AB"
        />
        <path
          d="M94.3759 23.6523C97.3958 30.6987 93.3693 38.7516 93.3693 38.7516C93.3693 38.7516 84.3097 35.7318 82.2964 28.6854C79.2766 21.6391 83.303 13.5861 83.303 13.5861C83.303 13.5861 92.3626 16.606 94.3759 23.6523Z"
          fill="#FFE3AB"
        />
        <path
          d="M139.674 131.361C142.694 138.407 138.667 146.46 138.667 146.46C138.667 146.46 129.608 143.44 127.594 136.394C124.575 129.348 128.601 121.295 128.601 121.295C128.601 121.295 136.654 124.314 139.674 131.361Z"
          fill="#FFE3AB"
        />
        <path
          d="M54.111 96.1291C61.1574 93.1092 69.2103 97.1357 69.2103 97.1357C69.2103 97.1357 66.1905 106.195 59.1441 108.209C52.0978 111.228 44.0448 107.202 44.0448 107.202C44.0448 107.202 47.0647 99.1489 54.111 96.1291Z"
          fill="#FFE3AB"
        />
        <path
          d="M162.826 50.8311C169.873 47.8112 177.926 51.8377 177.926 51.8377C177.926 51.8377 174.906 60.8973 167.859 62.9106C160.813 65.9304 152.76 61.9039 152.76 61.9039C152.76 61.9039 155.78 53.851 162.826 50.8311Z"
          fill="#FFE3AB"
        />
        <path
          d="M82.2964 131.361C85.3163 124.314 93.3693 121.295 93.3693 121.295C93.3693 121.295 97.3958 129.348 94.3759 136.394C91.356 143.44 83.303 146.46 83.303 146.46C83.303 146.46 79.2766 138.407 82.2964 131.361Z"
          fill="#FFE3AB"
        />
        <path
          d="M126.588 23.6523C129.608 16.606 137.661 13.5861 137.661 13.5861C137.661 13.5861 141.687 21.6391 138.667 28.6854C135.647 35.7318 127.594 38.7516 127.594 38.7516C127.594 38.7516 123.568 29.692 126.588 23.6523Z"
          fill="#FFE3AB"
        />
        <path
          d="M120.548 22.6457C120.548 31.7053 111.489 39.7583 111.489 39.7583C111.489 39.7583 102.429 32.7119 102.429 22.6457C102.429 12.5795 111.489 5.53313 111.489 5.53313C111.489 5.53313 120.548 12.5795 120.548 22.6457Z"
          fill="url(#paint0_linear_2_1880)"
        />
        <path
          d="M120.548 139.414C120.548 148.473 111.489 156.526 111.489 156.526C111.489 156.526 102.429 149.48 102.429 139.414C102.429 130.354 111.489 122.301 111.489 122.301C111.489 122.301 120.548 130.354 120.548 139.414Z"
          fill="url(#paint1_linear_2_1880)"
        />
        <path
          d="M53.1045 71.9702C62.1641 71.9702 70.2171 81.0298 70.2171 81.0298C70.2171 81.0298 62.1641 89.0827 53.1045 89.0827C44.0449 89.0827 35.9919 81.0298 35.9919 81.0298C35.9919 81.0298 44.0449 71.9702 53.1045 71.9702Z"
          fill="url(#paint2_linear_2_1880)"
        />
        <path
          d="M169.873 71.9702C178.932 71.9702 186.985 81.0298 186.985 81.0298C186.985 81.0298 179.939 90.0893 169.873 90.0893C160.813 90.0893 152.76 81.0298 152.76 81.0298C152.76 81.0298 160.813 71.9702 169.873 71.9702Z"
          fill="url(#paint3_linear_2_1880)"
        />
        <path
          d="M64.1774 116.262C71.2237 109.215 82.2966 110.222 82.2966 110.222C82.2966 110.222 83.3032 121.295 76.2569 128.341C69.2105 135.387 58.1377 134.381 58.1377 134.381C58.1377 134.381 57.131 122.301 64.1774 116.262Z"
          fill="url(#paint4_linear_2_1880)"
        />
        <path
          d="M146.72 33.7185C153.767 26.6722 164.839 27.6788 164.839 27.6788C164.839 27.6788 165.846 38.7517 158.8 45.798C152.76 51.8377 140.681 50.8311 140.681 50.8311C140.681 50.8311 140.681 39.7583 146.72 33.7185Z"
          fill="url(#paint5_linear_2_1880)"
        />
        <path
          d="M146.72 128.341C139.674 121.295 140.681 110.222 140.681 110.222C140.681 110.222 151.753 109.215 158.8 116.262C165.846 123.308 164.84 134.381 164.84 134.381C164.84 134.381 153.767 135.387 146.72 128.341Z"
          fill="url(#paint6_linear_2_1880)"
        />
        <path
          d="M64.1774 45.798C57.131 38.7517 58.1377 27.6788 58.1377 27.6788C58.1377 27.6788 69.2105 26.6722 76.2569 33.7185C82.2966 39.7583 82.2966 50.8311 82.2966 50.8311C82.2966 50.8311 70.2171 51.8377 64.1774 45.798Z"
          fill="url(#paint7_linear_2_1880)"
        />
        <path
          d="M162.826 109.215C155.78 106.195 152.76 98.1423 152.76 98.1423C152.76 98.1423 160.813 94.1158 167.859 97.1357C174.906 100.156 177.926 108.209 177.926 108.209C177.926 108.209 169.873 112.235 162.826 109.215Z"
          fill="url(#paint8_linear_2_1880)"
        />
        <path
          d="M55.1177 64.9238C48.0713 61.9039 45.0515 53.851 45.0515 53.851C45.0515 53.851 53.1044 49.8245 60.1508 52.8443C67.1971 55.8642 70.217 63.9172 70.217 63.9172C70.217 63.9172 62.164 67.9437 55.1177 64.9238Z"
          fill="url(#paint9_linear_2_1880)"
        />
        <path
          d="M95.3826 23.6523C98.4025 30.6987 94.376 38.7516 94.376 38.7516C94.376 38.7516 85.3164 35.7318 83.3031 28.6854C80.2833 22.6457 84.3098 14.5927 84.3098 14.5927C84.3098 14.5927 92.3627 17.6126 95.3826 23.6523Z"
          fill="url(#paint10_linear_2_1880)"
        />
        <path
          d="M140.681 132.367C143.7 139.414 139.674 147.467 139.674 147.467C139.674 147.467 130.614 144.447 128.601 137.401C125.581 130.354 129.608 122.301 129.608 122.301C129.608 122.301 137.661 125.321 140.681 132.367Z"
          fill="url(#paint11_linear_2_1880)"
        />
        <path
          d="M55.1177 97.1357C62.164 94.1158 70.217 98.1423 70.217 98.1423C70.217 98.1423 67.1971 107.202 60.1508 109.215C53.1044 112.235 45.0515 108.209 45.0515 108.209C45.0515 108.209 48.0713 100.156 55.1177 97.1357Z"
          fill="url(#paint12_linear_2_1880)"
        />
        <path
          d="M162.826 51.8377C169.873 48.8179 177.926 52.8443 177.926 52.8443C177.926 52.8443 174.906 61.9039 167.859 63.9172C160.813 66.937 152.76 62.9106 152.76 62.9106C152.76 62.9106 155.78 54.8576 162.826 51.8377Z"
          fill="url(#paint13_linear_2_1880)"
        />
        <path
          d="M83.3031 132.367C86.323 125.321 94.376 122.301 94.376 122.301C94.376 122.301 98.4025 130.354 95.3826 137.401C92.3627 144.447 84.3098 147.467 84.3098 147.467C84.3098 147.467 80.2833 139.414 83.3031 132.367Z"
          fill="url(#paint14_linear_2_1880)"
        />
        <path
          d="M127.594 23.6523C130.614 16.606 138.667 13.5861 138.667 13.5861C138.667 13.5861 142.694 21.6391 139.674 28.6854C136.654 35.7318 128.601 38.7516 128.601 38.7516C128.601 38.7516 124.575 30.6987 127.594 23.6523Z"
          fill="url(#paint15_linear_2_1880)"
        />
        <g style={{ 'mix-blend-mode': 'multiply' }}>
          <path
            opacity="0.047619"
            d="M163.833 139.414C140.68 159.546 108.469 163.573 79.2766 146.46C41.0249 123.308 49.0779 91.096 67.1971 90.0893C84.3097 89.0827 99.409 95.1224 111.488 83.043C124.575 68.9503 124.575 53.851 127.594 38.7516C130.614 20.6324 152.76 15.5993 176.919 40.7649C202.084 67.9437 194.031 114.248 163.833 139.414Z"
            fill="#F9FBFB"
          />
          <path
            opacity="0.095238"
            d="M163.833 138.407C140.681 157.533 109.475 162.566 82.2965 145.454C44.0449 123.308 51.0912 92.1026 68.2038 91.096C84.3097 90.0894 100.416 97.1357 112.495 84.0496C125.581 69.9569 125.581 54.8576 128.601 39.7583C131.621 22.6457 152.76 17.6126 175.912 42.7781C200.071 68.9503 192.018 113.242 163.833 138.407Z"
            fill="#F3F6F7"
          />
          <path
            opacity="0.1429"
            d="M162.826 136.394C140.68 155.52 110.482 159.546 83.303 144.447C47.0646 123.308 53.1043 93.1092 69.2103 92.1026C84.3096 91.096 100.416 98.1423 113.502 85.0562C126.588 70.9635 126.588 55.8642 128.601 40.7649C131.621 24.6589 151.753 19.6258 173.899 43.7848C198.058 68.9503 191.012 112.235 162.826 136.394Z"
            fill="#EEF2F4"
          />
          <path
            opacity="0.1905"
            d="M161.819 135.387C140.68 153.507 111.488 158.54 84.3096 143.44C48.0712 123.308 53.1043 94.1158 69.2103 93.1092C84.3096 92.1026 100.416 100.156 114.508 85.0562C127.594 70.9635 126.588 55.8642 129.608 41.7715C132.627 25.6656 152.76 20.6325 172.892 44.7914C196.045 68.9503 188.998 111.228 161.819 135.387Z"
            fill="#E8EDF0"
          />
          <path
            opacity="0.2381"
            d="M160.813 133.374C139.674 151.493 112.495 156.526 86.323 142.434C51.0912 124.315 56.1243 95.1225 71.2236 94.1158C85.3163 93.1092 102.429 101.162 116.522 86.0629C129.608 71.9702 128.601 57.8775 131.621 42.7781C133.634 26.6722 153.767 22.6457 173.899 45.798C193.025 69.9569 187.992 110.222 160.813 133.374Z"
            fill="#E2E9EC"
          />
          <path
            opacity="0.2857"
            d="M160.813 132.367C140.681 150.487 113.502 154.513 88.3362 141.427C54.1111 124.314 57.1309 96.1291 72.2303 95.1224C86.323 94.1158 103.436 103.175 117.528 87.0695C130.614 71.9702 129.608 58.8841 131.621 43.7847C133.634 28.6854 152.76 24.6589 171.886 46.8046C191.012 69.9569 185.979 109.215 160.813 132.367Z"
            fill="#DCE4E8"
          />
          <path
            opacity="0.3333"
            d="M159.806 130.354C140.68 147.467 114.508 152.5 90.3494 140.42C57.1309 124.314 59.1441 98.1423 73.2368 96.1291C86.3229 95.1225 104.442 104.182 118.535 88.0761C131.621 72.9768 130.614 59.8907 132.627 45.798C134.641 30.6987 152.76 26.6722 170.879 48.8179C188.998 70.9635 184.972 108.209 159.806 130.354Z"
            fill="#D7E0E5"
          />
          <path
            opacity="0.381"
            d="M158.8 129.348C139.674 146.46 115.515 150.487 91.3561 140.42C58.1375 125.321 60.1508 100.156 73.2369 98.1423C85.3163 97.1357 103.436 107.202 118.535 89.0827C132.628 73.9834 131.621 60.8973 132.628 46.8046C134.641 32.7119 151.753 28.6854 168.866 49.8245C186.985 70.9635 182.959 107.202 158.8 129.348Z"
            fill="#D1DCE1"
          />
          <path
            opacity="0.4286"
            d="M158.8 127.334C140.681 143.44 116.522 148.473 93.3693 138.407C61.1574 124.314 62.164 100.156 75.2501 98.1423C87.3296 97.1357 105.449 107.202 121.555 89.0827C134.641 73.9834 133.634 60.8973 134.641 46.8046C134.641 33.7185 151.753 30.6987 168.866 50.8311C184.972 70.9635 181.952 106.195 158.8 127.334Z"
            fill="#CBD7DD"
          />
          <path
            opacity="0.4762"
            d="M157.793 126.328C140.681 142.434 117.528 147.467 95.3826 138.407C64.1773 125.321 63.1707 101.162 75.2501 100.156C86.323 99.1489 105.449 109.215 121.555 91.096C134.641 75.9966 132.628 62.9106 133.634 49.8245C134.641 36.7384 150.747 32.7119 166.853 52.8443C182.959 71.9702 180.945 105.189 157.793 126.328Z"
            fill="#C5D3D9"
          />
          <path
            opacity="0.5238"
            d="M156.786 124.315C139.674 139.414 118.535 144.447 96.3891 136.394C66.1905 124.314 64.1772 102.169 76.2567 100.156C86.3229 98.1423 106.455 110.222 122.561 91.096C135.647 75.9966 133.634 62.9106 134.641 49.8245C135.647 36.7384 150.747 33.7185 165.846 53.851C180.945 71.9702 178.932 104.182 156.786 124.315Z"
            fill="#C0CED6"
          />
          <path
            opacity="0.5714"
            d="M155.78 123.308C139.674 138.407 118.535 143.44 98.4024 136.394C69.2103 126.328 66.1905 104.182 77.2633 102.169C87.3295 100.156 107.462 112.235 123.568 92.1026C136.654 77.0033 134.641 63.9172 135.647 50.8311C135.647 38.7516 150.747 35.7318 164.839 54.8576C178.932 72.9768 177.925 103.175 155.78 123.308Z"
            fill="#BACAD2"
          />
          <path
            opacity="0.619"
            d="M155.78 121.295C140.68 136.394 120.548 141.427 100.416 134.381C71.2235 125.321 68.2037 104.182 79.2765 102.169C88.3361 100.156 108.469 113.242 126.588 92.1026C139.674 77.0033 137.661 64.9238 137.661 51.8377C137.661 39.7583 151.753 36.7384 165.846 55.8642C176.919 72.9768 175.912 102.169 155.78 121.295Z"
            fill="#B4C5CE"
          />
          <path
            opacity="0.6667"
            d="M154.773 120.288C139.674 134.381 121.555 140.42 101.422 134.381C73.2369 126.328 69.2104 106.195 79.2766 104.182C87.3296 102.169 108.469 115.255 126.588 94.1158C139.674 78.0099 137.661 66.937 137.661 53.851C137.661 41.7715 150.747 39.7583 163.833 57.8775C174.906 72.9768 174.906 101.162 154.773 120.288Z"
            fill="#AEC1CA"
          />
          <path
            opacity="0.7143"
            d="M153.767 118.275C139.674 132.367 122.561 137.401 103.435 133.374C76.2567 126.328 71.2236 107.202 80.2831 105.189C88.3361 103.175 109.475 117.268 127.594 95.1224C140.68 79.0165 138.667 67.9437 137.661 54.8576C137.661 43.7847 150.747 40.7649 161.82 58.8841C172.892 73.9834 172.892 100.156 153.767 118.275Z"
            fill="#A9BDC7"
          />
          <path
            opacity="0.7619"
            d="M152.76 117.268C139.674 130.354 122.561 136.394 104.442 132.367C78.2699 126.328 72.2301 108.209 81.2897 106.195C88.3361 104.182 110.482 118.275 128.601 95.1225C141.687 79.0165 139.674 67.9437 138.667 55.8642C137.661 44.7914 150.747 42.7781 160.813 59.8907C170.879 73.9834 171.886 98.1423 152.76 117.268Z"
            fill="#A3B8C3"
          />
          <path
            opacity="0.8095"
            d="M152.76 115.255C139.674 128.341 124.575 134.381 107.462 131.361C81.2898 127.334 75.2501 110.222 83.3031 107.202C90.3494 105.189 112.495 120.288 130.614 96.1291C143.7 80.0231 140.681 68.9503 139.674 56.8708C138.667 46.8046 150.747 44.7914 160.813 60.8973C168.866 74.99 169.873 97.1357 152.76 115.255Z"
            fill="#9DB4BF"
          />
          <path
            opacity="0.8571"
            d="M151.753 114.248C139.674 127.334 125.581 132.367 108.469 130.354C83.3031 127.334 75.2501 111.228 83.3031 108.209C89.3428 106.195 111.488 121.295 131.621 97.1357C144.707 81.0298 141.687 69.9569 140.68 58.8841C139.674 48.8179 150.747 46.8046 159.806 62.9106C166.853 74.99 168.866 96.1291 151.753 114.248Z"
            fill="#97AFBB"
          />
          <path
            opacity="0.9048"
            d="M150.747 112.235C139.674 124.314 125.581 130.354 109.475 129.348C85.3162 127.334 76.2567 112.235 84.3096 109.215C89.3427 107.202 112.495 123.308 132.627 98.1423C145.714 82.0364 142.694 70.9635 141.687 59.8907C140.68 50.8311 150.747 48.8179 158.8 63.9172C164.839 74.99 166.853 95.1225 150.747 112.235Z"
            fill="#92ABB8"
          />
          <path
            opacity="0.9524"
            d="M150.747 111.228C139.674 123.308 127.594 129.348 112.495 128.341C89.3427 127.334 79.2765 113.242 86.3229 110.222C91.356 108.209 114.508 124.314 134.641 98.1423C147.727 82.0364 144.707 70.9635 142.694 59.8907C141.687 50.8311 150.747 48.8179 157.793 63.9172C162.826 75.9966 165.846 94.1158 150.747 111.228Z"
            fill="#8CA6B4"
          />
          <path
            d="M149.74 109.215C139.674 120.288 128.601 126.328 113.502 127.334C91.3561 128.341 80.2832 114.248 86.323 111.228C90.3494 109.215 114.508 126.328 134.641 99.149C147.727 83.043 144.707 71.9702 142.694 61.9039C140.681 53.851 150.747 51.8377 156.786 66.9371C160.813 75.9967 163.833 93.1092 149.74 109.215Z"
            fill="#86A2B0"
          />
        </g>
        <path
          d="M110.482 127.334C136.611 127.334 157.793 106.152 157.793 80.0231C157.793 53.8939 136.611 32.7119 110.482 32.7119C84.3527 32.7119 63.1707 53.8939 63.1707 80.0231C63.1707 106.152 84.3527 127.334 110.482 127.334Z"
          fill="#FFE3AB"
        />
        <path
          d="M159.806 81.0298C159.806 107.202 138.667 128.341 112.495 128.341C86.3229 128.341 64.1772 107.202 64.1772 81.0298C64.1772 54.8576 85.3163 32.7119 111.488 32.7119C137.661 32.7119 159.806 54.8576 159.806 81.0298Z"
          fill="url(#paint16_linear_2_1880)"
        />
        <g style={{ 'mix-blend-mode': 'multiply' }}>
          <path
            opacity="0.047619"
            d="M216.177 182.699C230.27 170.619 228.257 134.381 221.21 124.314C212.151 111.228 201.078 103.175 193.025 99.1489C183.965 95.1225 160.813 91.096 149.74 91.096C134.641 91.096 118.535 95.1224 106.455 98.1423C90.3495 101.162 64.1774 111.228 51.0913 124.314C36.9986 140.42 49.078 172.632 53.1045 177.665C60.1509 186.725 68.2039 195.785 79.2767 200.818C89.3429 205.851 98.4025 204.844 106.455 205.851C112.495 205.851 137.661 209.877 153.767 206.857C164.84 204.844 182.959 200.818 187.992 198.804C192.018 194.778 204.098 192.765 216.177 182.699Z"
            fill="#F9FBFB"
          />
          <path
            opacity="0.095238"
            d="M214.164 181.692C228.257 170.619 226.243 134.381 219.197 124.314C210.137 111.228 200.071 104.182 191.012 99.1489C181.952 95.1225 158.8 91.096 147.727 91.096C132.628 91.096 117.528 94.1158 104.442 98.1423C91.3561 101.162 64.1773 111.228 52.0978 124.314C38.0051 139.414 50.0846 170.619 54.1111 175.652C61.1574 183.705 68.2038 192.765 79.2766 197.798C89.3428 202.831 98.4024 201.824 105.449 202.831C111.489 203.838 135.647 206.857 151.753 203.838C162.826 201.824 179.939 197.798 184.972 194.778C190.005 193.771 202.084 190.752 214.164 181.692Z"
            fill="#F4F6F8"
          />
          <path
            opacity="0.1429"
            d="M211.144 180.685C225.237 169.612 223.223 135.387 216.177 125.321C207.118 112.235 197.051 105.189 187.992 101.162C179.939 97.1357 157.793 93.1092 146.72 93.1092C131.621 93.1092 116.522 96.1291 104.442 99.1489C91.3561 103.175 64.1773 113.242 53.1044 125.321C40.0184 140.42 50.0846 170.619 55.1177 175.652C62.164 183.705 69.2104 192.765 80.2832 197.798C90.3494 201.824 99.409 201.824 106.455 201.824C112.495 202.831 135.647 206.857 151.753 202.831C162.826 200.818 179.939 196.791 183.965 193.771C187.992 191.758 200.071 189.745 211.144 180.685Z"
            fill="#EEF2F4"
          />
          <path
            opacity="0.1905"
            d="M209.131 178.672C223.224 167.599 221.21 135.387 214.164 124.314C205.104 111.228 195.038 104.182 186.985 100.156C178.932 96.1291 158.8 92.1026 147.727 92.1026C133.634 91.096 118.535 95.1225 105.449 98.1423C92.3628 102.169 66.1907 112.235 55.1178 124.314C41.0251 138.407 51.0913 168.606 56.1244 173.639C62.1642 181.692 69.2105 189.745 80.2834 194.778C90.3496 198.804 98.4025 197.798 105.449 198.804C111.489 199.811 133.634 203.838 149.74 200.818C160.813 198.804 176.919 193.771 181.952 191.758C185.979 189.745 198.058 187.732 209.131 178.672Z"
            fill="#E9EDF1"
          />
          <path
            opacity="0.2381"
            d="M207.118 177.665C220.204 167.599 219.197 135.387 212.151 125.321C203.091 112.235 193.025 106.195 184.972 102.169C176.919 98.1423 157.793 94.1158 146.72 94.1158C132.628 93.1092 117.528 97.1357 105.449 100.156C92.3627 104.182 66.1905 114.248 56.1243 125.321C44.0449 138.407 53.1045 167.599 58.1376 173.639C64.1773 181.692 70.217 189.745 81.2899 194.778C91.3561 198.804 99.4091 197.798 106.455 198.804C112.495 199.811 133.634 203.838 149.74 200.818C160.813 198.804 175.912 193.771 180.945 191.758C183.965 187.732 196.045 186.725 207.118 177.665Z"
            fill="#E3E9ED"
          />
          <path
            opacity="0.2857"
            d="M204.098 176.659C217.184 166.593 216.177 136.394 209.131 125.321C200.071 112.235 191.012 106.195 181.952 102.169C173.899 98.1423 155.78 94.1158 145.714 94.1158C132.628 93.1092 116.522 96.1291 104.442 100.156C91.3561 104.182 66.1906 114.248 55.1177 125.321C43.0383 138.407 51.0912 165.586 56.1243 172.632C62.1641 179.679 68.2038 188.738 79.2766 192.765C89.3429 196.791 97.3958 195.785 103.436 196.791C108.469 197.798 129.608 202.831 145.714 199.811C156.786 197.798 171.886 192.765 175.912 189.745C181.952 185.718 193.025 184.712 204.098 176.659Z"
            fill="#DEE5EA"
          />
          <path
            opacity="0.3333"
            d="M202.085 175.652C215.171 166.593 214.164 137.401 207.118 126.328C199.065 112.235 188.998 108.209 180.945 104.182C172.892 100.156 155.78 96.1291 145.714 96.1291C132.628 95.1224 117.528 98.1423 105.449 101.162C92.3627 105.189 67.1972 115.255 57.131 125.321C46.0581 137.401 53.1045 164.579 58.1376 170.619C64.1773 177.665 69.2104 185.718 80.2833 190.752C90.3495 194.778 98.4025 192.765 104.442 193.771C109.475 194.778 129.608 199.811 145.714 196.791C156.787 194.778 170.879 188.738 174.906 186.725C179.939 184.712 191.012 183.705 202.085 175.652Z"
            fill="#D8E0E6"
          />
          <path
            opacity="0.381"
            d="M200.071 173.639C213.157 164.579 212.151 136.394 205.104 125.321C197.051 111.228 186.985 107.202 178.932 103.175C171.886 99.1489 155.78 96.1291 144.707 95.1224C131.621 94.1158 116.522 97.1357 105.449 100.156C92.3627 104.182 67.1971 114.248 58.1375 124.314C47.0647 136.394 54.111 161.559 59.1441 168.606C64.1772 175.652 69.2104 183.705 80.2832 187.732C90.3494 191.758 97.3958 189.745 103.435 190.752C108.469 191.758 127.594 196.791 143.7 194.778C154.773 192.765 167.859 186.725 172.892 184.712C177.926 182.699 188.998 181.692 200.071 173.639Z"
            fill="#D3DCE3"
          />
          <path
            opacity="0.4286"
            d="M197.051 172.632C210.137 163.573 209.131 137.401 202.084 126.328C194.032 112.235 183.965 108.209 175.912 105.189C168.866 102.169 153.767 98.1423 143.7 97.1357C131.621 95.1225 117.528 98.1423 105.449 101.162C92.3627 105.189 68.2038 115.255 59.1442 124.314C49.078 135.387 54.1111 160.553 60.1508 167.599C65.1839 173.639 70.217 181.692 81.2899 186.725C90.3495 190.752 98.4024 188.738 104.442 189.745C109.475 190.752 127.594 196.791 143.7 193.771C155.78 191.758 167.859 185.718 171.886 183.705C175.912 180.685 186.985 180.685 197.051 172.632Z"
            fill="#CDD8DF"
          />
          <path
            opacity="0.4762"
            d="M195.038 171.626C207.118 163.573 207.118 137.401 200.071 126.328C192.018 112.235 182.959 109.215 174.906 105.189C167.859 102.169 153.767 98.1423 143.7 97.1357C131.621 96.1291 116.522 98.1423 105.449 102.169C92.3628 106.195 68.2039 116.262 60.1509 125.321C50.0847 135.387 55.1178 159.546 61.1575 167.599C66.1906 173.639 70.2171 181.692 81.29 185.718C90.3495 188.738 98.4025 186.725 103.436 187.732C108.469 188.738 125.581 194.778 141.687 191.758C153.767 189.745 164.84 183.705 168.866 181.692C173.899 178.672 183.965 178.672 195.038 171.626Z"
            fill="#C8D3DC"
          />
          <path
            opacity="0.5238"
            d="M193.025 170.619C205.104 162.566 205.104 138.407 198.058 127.334C190.005 113.242 180.945 110.222 172.892 107.202C165.846 104.182 153.767 100.156 143.7 99.1489C132.628 98.1423 117.528 100.156 105.449 103.175C92.3627 107.202 69.2104 117.268 61.1575 125.321C52.0979 135.387 56.1244 158.54 62.1641 165.586C67.1972 171.626 70.2171 179.679 81.2899 183.705C90.3495 186.725 98.4025 184.712 103.436 185.718C108.469 186.725 124.575 193.771 140.681 190.752C152.76 188.738 163.833 181.692 166.853 179.679C170.879 176.659 181.952 177.665 193.025 170.619Z"
            fill="#C2CFD8"
          />
          <path
            opacity="0.5714"
            d="M190.005 168.606C202.085 160.553 202.085 138.407 195.038 126.328C186.985 112.235 177.926 110.222 169.873 106.195C162.826 103.175 151.753 99.1489 141.687 98.1423C130.614 97.1357 115.515 99.1489 104.442 102.169C91.3561 106.195 68.2038 116.262 61.1575 123.308C52.0979 132.367 55.1177 154.513 62.1641 162.566C67.1972 169.612 70.2171 177.665 81.2899 181.692C90.3495 184.712 97.3959 182.699 102.429 183.705C107.462 184.712 122.561 191.758 138.667 188.738C150.747 186.725 160.813 179.679 163.833 177.665C168.866 175.652 179.939 175.652 190.005 168.606Z"
            fill="#BDCAD5"
          />
          <path
            opacity="0.619"
            d="M187.992 167.599C200.071 160.553 200.071 138.407 194.032 127.334C186.985 113.242 176.919 111.228 169.873 108.209C163.833 105.189 152.76 101.162 142.694 100.156C131.621 99.1489 117.528 100.156 105.449 104.182C92.3628 108.209 69.2105 118.275 62.1641 125.321C54.1112 134.381 56.1244 155.52 63.1708 163.573C67.1972 168.606 70.2171 176.659 81.2899 180.685C90.3495 183.705 97.3959 180.685 102.429 182.699C107.462 183.705 121.555 190.752 137.661 188.738C149.74 186.725 158.8 179.679 162.826 177.665C166.853 173.639 177.926 174.646 187.992 167.599Z"
            fill="#B7C6D1"
          />
          <path
            opacity="0.6667"
            d="M185.979 166.593C197.051 159.546 198.058 139.414 192.018 127.334C184.972 113.242 175.912 112.235 167.859 108.209C161.82 105.189 151.753 101.162 142.694 100.156C132.628 98.1423 117.528 100.156 106.455 103.175C94.376 107.202 71.2237 117.268 64.1773 123.308C56.1244 131.361 58.1376 151.493 65.184 160.553C69.2105 165.586 71.2237 173.639 82.2965 176.659C91.3561 179.679 98.4025 176.659 102.429 177.665C107.462 178.672 120.548 186.725 136.654 183.705C148.734 181.692 157.793 174.646 160.813 172.632C164.84 171.626 174.906 172.632 185.979 166.593Z"
            fill="#B2C2CE"
          />
          <path
            opacity="0.7143"
            d="M182.959 165.586C194.031 158.54 195.038 140.42 188.998 128.341C181.952 114.248 172.892 113.242 164.839 110.222C158.8 107.202 150.747 103.175 140.68 102.169C130.614 100.156 116.522 102.169 105.449 105.189C93.3693 109.215 70.217 119.281 64.1772 125.321C57.1309 132.367 57.1309 152.5 65.1839 161.559C69.2103 166.593 70.217 173.639 82.2964 177.665C91.356 180.685 98.4024 177.665 102.429 178.672C107.462 179.679 119.541 187.732 135.647 185.718C147.727 183.705 155.78 175.652 158.8 174.646C162.826 169.612 172.892 171.626 182.959 165.586Z"
            fill="#ACBDCA"
          />
          <path
            opacity="0.7619"
            d="M180.945 164.579C192.018 158.54 193.025 140.42 186.985 128.341C179.939 114.248 170.879 113.242 163.833 110.222C157.793 107.202 150.747 104.182 141.687 102.169C132.628 100.156 117.528 102.169 106.455 105.189C94.3759 109.215 72.2302 119.281 66.1905 124.314C59.1441 131.361 59.1441 149.48 66.1905 158.54C70.217 162.566 71.2236 170.619 82.2964 173.639C91.356 175.652 97.3958 173.639 101.422 174.646C106.455 175.652 117.528 184.712 133.634 181.692C145.714 179.679 153.767 171.626 155.78 169.612C160.813 167.599 170.879 169.612 180.945 164.579Z"
            fill="#A7B9C7"
          />
          <path
            opacity="0.8095"
            d="M178.932 162.566C190.005 156.526 191.012 140.42 184.972 128.341C177.925 114.248 168.866 114.248 161.82 111.228C155.78 108.209 149.74 105.189 140.68 103.175C131.621 101.162 116.522 102.169 106.455 106.195C94.3759 110.222 72.2302 120.288 67.1971 125.321C61.1574 131.361 60.1507 149.48 67.1971 158.54C70.217 161.559 71.2236 169.612 82.2964 172.632C90.3494 174.646 97.3957 171.626 101.422 172.632C106.455 173.639 116.522 182.699 132.628 180.685C144.707 178.672 151.753 170.619 154.773 168.606C158.8 166.593 168.866 168.606 178.932 162.566Z"
            fill="#A1B5C3"
          />
          <path
            opacity="0.8571"
            d="M175.912 161.559C186.985 156.526 187.992 140.42 181.952 128.341C174.906 114.248 166.853 114.248 158.8 111.228C153.767 109.215 148.734 105.189 139.674 103.175C130.614 101.162 116.522 102.169 105.449 105.189C93.3693 109.215 71.2236 119.281 67.1971 123.308C61.1574 129.348 59.1442 145.454 67.1971 155.52C71.2236 160.553 71.2236 167.599 82.2965 170.619C90.3494 172.632 97.3958 169.612 101.422 170.619C105.449 172.632 115.515 180.685 131.621 178.672C143.7 176.659 149.74 167.599 152.76 166.593C156.786 164.579 165.846 166.593 175.912 161.559Z"
            fill="#9CB0C0"
          />
          <path
            opacity="0.9048"
            d="M173.899 160.553C183.965 155.52 185.979 141.427 179.939 129.348C173.899 115.255 164.84 116.262 157.793 112.235C152.76 110.222 148.734 106.195 139.674 104.182C131.621 102.169 116.522 103.175 106.455 106.195C94.376 110.222 73.237 120.288 68.2039 124.314C63.1708 129.348 60.1509 145.454 68.2039 155.52C71.2237 158.54 71.2237 166.593 82.2966 168.606C90.3496 170.619 97.3959 167.599 100.416 168.606C104.442 170.619 113.502 179.679 129.608 176.659C141.687 174.646 147.727 165.586 149.74 164.579C154.773 162.566 163.833 165.586 173.899 160.553Z"
            fill="#96ACBC"
          />
          <path
            opacity="0.9524"
            d="M171.886 159.546C181.952 154.513 183.965 142.434 177.926 129.348C171.886 115.255 162.826 116.262 155.78 113.242C150.747 111.228 147.727 107.202 138.667 105.189C130.614 103.175 116.522 104.182 105.449 107.202C93.3694 111.228 72.2304 121.295 68.2039 124.314C63.1708 128.341 60.1509 143.44 68.2039 153.507C71.2237 156.526 70.2171 164.579 81.29 166.593C89.3429 168.606 95.3827 164.579 99.4091 166.593C103.436 168.606 111.489 177.665 127.595 175.652C139.674 173.639 144.707 164.579 146.72 163.573C152.76 160.553 161.82 163.573 171.886 159.546Z"
            fill="#91A7B9"
          />
          <path
            d="M168.866 157.533C178.932 153.507 180.945 141.427 174.906 129.348C168.866 115.255 159.806 116.262 152.76 113.242C147.727 111.228 145.714 107.202 137.661 105.189C130.614 103.175 115.515 103.175 105.449 107.202C94.3759 111.228 74.2435 121.295 70.217 124.314C66.1905 128.341 61.1574 142.434 70.217 152.5C73.2369 155.52 71.2236 162.566 83.3031 165.586C91.356 167.599 97.3958 163.573 100.416 164.579C104.442 166.593 111.488 176.659 127.594 173.639C139.674 171.626 143.7 162.566 146.72 160.553C149.74 158.54 159.806 162.566 168.866 157.533Z"
            fill="#8BA3B5"
          />
        </g>
        <path
          d="M155.78 111.228C154.773 111.228 154.773 111.228 153.767 111.228C150.747 103.175 142.694 97.1357 133.634 97.1357C130.614 97.1357 128.601 98.1423 125.581 98.1423C122.561 90.0893 115.515 85.0562 106.455 85.0562C98.4024 85.0562 91.3561 90.0893 88.3362 98.1423C87.3296 98.1423 86.323 98.1423 85.3164 98.1423C76.2568 98.1423 68.2038 105.189 67.1972 114.248C66.1906 114.248 64.1773 114.248 63.1707 114.248C52.0978 114.248 43.0383 123.308 43.0383 134.381C43.0383 145.454 52.0978 154.513 63.1707 154.513C63.1707 154.513 63.1707 154.513 64.1773 154.513C66.1906 162.566 73.2369 168.606 82.2965 168.606C89.3429 168.606 95.3826 164.579 98.4024 159.546C102.429 167.599 111.489 172.632 120.548 172.632C130.614 172.632 139.674 166.593 143.7 157.533C147.727 159.546 151.753 160.553 155.78 160.553C168.866 160.553 179.939 149.48 179.939 136.394C179.939 121.295 169.873 111.228 155.78 111.228Z"
          fill="white"
        />
        <path
          d="M156.787 111.228C155.78 111.228 155.78 111.228 154.773 111.228C151.753 103.175 143.7 97.1357 134.641 97.1357C131.621 97.1357 129.608 98.1423 126.588 98.1423C123.568 90.0893 116.522 85.0562 107.462 85.0562C99.4091 86.0629 92.3628 91.096 89.3429 98.1423C88.3363 98.1423 87.3297 98.1423 86.323 98.1423C77.2634 98.1423 69.2105 105.189 68.2039 114.248C67.1972 114.248 65.184 114.248 64.1774 114.248C53.1045 114.248 44.0449 123.308 44.0449 134.381C44.0449 145.454 53.1045 154.513 64.1774 154.513C64.1774 154.513 64.1774 154.513 65.184 154.513C67.1972 162.566 74.2436 168.606 83.3032 168.606C90.3495 168.606 96.3893 164.579 99.4091 159.546C103.436 167.599 112.495 172.632 121.555 172.632C131.621 172.632 140.681 166.593 144.707 157.533C148.734 159.546 152.76 160.553 156.787 160.553C169.873 160.553 180.945 149.48 180.945 136.394C180.945 122.301 169.873 111.228 156.787 111.228Z"
          fill="#E9F2F5"
        />
        <g style={{ 'mix-blend-mode': 'multiply' }}>
          <path
            opacity="0.047619"
            d="M148.734 155.52C157.793 142.434 153.767 117.268 147.727 108.209C139.674 96.1291 126.588 95.1225 118.535 91.096C110.482 87.0695 96.3892 77.0033 86.323 77.0033C73.2369 75.9966 65.184 81.0298 54.1111 84.0496C42.0317 88.0761 21.8992 106.195 10.8264 118.275C-2.2597 132.367 0.760164 153.507 3.78003 158.54C9.81976 166.593 17.8727 173.639 26.9323 178.672C36.9985 182.699 45.0515 181.692 51.0912 182.699C56.1244 182.699 62.1641 185.718 76.2568 182.699C86.323 180.685 90.3495 179.679 95.3826 178.672C105.449 175.652 137.661 171.626 148.734 155.52Z"
            fill="#F9FBFB"
          />
          <path
            opacity="0.095238"
            d="M146.72 154.513C155.78 141.427 151.753 117.268 145.714 108.209C137.661 96.1291 124.575 95.1225 116.522 91.096C109.475 87.0695 95.3826 77.0033 85.3164 75.9966C72.2303 75.9966 64.1773 81.0297 53.1045 83.043C41.025 86.0629 20.8926 105.189 10.8264 116.262C-0.246476 131.361 0.760145 152.5 4.78663 157.533C10.8264 164.579 17.8727 172.632 27.9389 176.659C36.9985 180.685 45.0515 179.679 51.0912 180.685C56.1243 180.685 62.1641 183.705 76.2568 181.692C86.323 179.679 90.3495 178.672 95.3826 177.665C105.449 173.639 135.647 170.619 146.72 154.513Z"
            fill="#F4F6F8"
          />
          <path
            opacity="0.1429"
            d="M145.714 154.513C154.773 142.434 150.747 118.275 144.707 109.215C136.654 97.1357 123.568 96.1291 115.515 93.1092C108.469 89.0827 94.376 79.0165 85.3164 78.0099C72.2303 78.0099 64.1774 82.0364 53.1045 85.0562C41.0251 88.0761 21.8993 107.202 11.833 118.275C0.760199 131.361 1.76682 151.493 5.79331 156.526C11.833 163.573 18.8794 171.626 27.939 175.652C36.9986 179.679 45.0516 178.672 51.0913 178.672C56.1244 178.672 62.1641 182.699 76.2568 179.679C86.3231 177.665 90.3495 176.659 95.3826 175.652C104.442 172.632 134.641 169.612 145.714 154.513Z"
            fill="#EEF2F4"
          />
          <path
            opacity="0.1905"
            d="M143.7 153.507C152.76 141.427 149.74 118.275 143.7 110.222C135.647 98.1423 122.561 98.1423 115.515 94.1158C108.469 91.096 95.3826 80.0231 86.323 79.0165C74.2435 79.0165 65.1839 83.043 55.1177 86.0629C43.0383 89.0827 23.9124 107.202 14.8528 118.275C3.78 130.354 3.78 150.487 7.80649 155.52C13.8462 162.566 19.886 169.612 29.9522 173.639C39.0118 177.665 47.0647 175.652 53.1045 176.659C58.1376 177.665 64.1773 180.685 78.27 177.665C88.3362 175.652 93.3693 174.646 97.3958 173.639C104.442 170.619 132.628 167.599 143.7 153.507Z"
            fill="#E9EDF1"
          />
          <path
            opacity="0.2381"
            d="M141.687 153.507C150.747 142.434 147.727 119.281 141.687 111.228C133.634 99.1489 120.548 99.1489 113.502 95.1225C106.455 91.096 94.376 80.0231 84.3097 80.0231C72.2303 79.0165 64.1773 84.0496 53.1045 87.0695C41.025 90.0894 22.9058 108.209 13.8462 118.275C2.77338 130.354 1.76675 149.48 6.79986 154.513C11.833 161.559 18.8793 168.606 28.9455 171.626C39.0118 174.646 46.0581 173.639 51.0912 174.646C56.1243 175.652 62.1641 178.672 76.2568 175.652C86.323 173.639 91.3561 171.626 95.3826 171.626C103.436 169.612 130.614 166.593 141.687 153.507Z"
            fill="#E3E9ED"
          />
          <path
            opacity="0.2857"
            d="M139.674 152.5C148.733 141.427 145.714 119.281 139.674 111.228C131.621 99.1489 119.541 99.1489 111.488 96.1291C105.449 92.1026 93.3693 81.0297 84.3097 81.0297C72.2302 80.0231 64.1773 84.0496 53.1044 87.0695C41.025 90.0893 22.9058 108.209 14.8528 118.275C4.78658 129.348 2.77333 148.473 7.80644 153.507C12.8396 159.546 18.8793 167.599 28.9455 170.619C39.0117 173.639 45.0514 171.626 51.0912 172.632C56.1243 173.639 62.164 176.659 76.2567 174.646C86.3229 172.632 91.356 170.619 95.3825 170.619C103.435 167.599 129.608 165.586 139.674 152.5Z"
            fill="#DEE5EA"
          />
          <path
            opacity="0.3333"
            d="M138.667 152.5C147.727 141.427 144.707 120.288 139.674 112.235C131.621 100.156 119.541 100.156 112.495 97.1357C104.442 93.1092 93.3693 82.0364 84.3097 81.0297C72.2302 81.0297 63.1706 84.0496 53.1044 87.0695C41.025 90.0893 23.9124 108.209 14.8528 117.268C4.78658 128.341 2.77333 146.46 7.80644 152.5C12.8396 158.54 18.8793 165.586 28.9455 168.606C39.0117 171.626 45.0514 169.612 51.0912 170.619C56.1243 171.626 62.164 174.646 76.2567 172.632C86.3229 170.619 91.356 168.606 95.3825 167.599C102.429 166.593 127.594 164.579 138.667 152.5Z"
            fill="#D8E0E6"
          />
          <path
            opacity="0.381"
            d="M136.654 151.493C145.714 141.427 143.7 120.288 137.661 112.235C129.608 100.156 117.528 100.156 110.482 97.1357C104.442 94.1158 92.3627 82.0364 83.3031 82.0364C72.2303 81.0298 63.1707 85.0562 53.1045 88.0761C41.025 91.096 23.9125 108.209 15.8595 117.268C5.79327 127.334 2.77341 145.454 7.80651 151.493C12.8396 157.533 18.8794 164.579 27.939 167.599C38.0052 170.619 44.0449 168.606 49.078 168.606C54.1111 169.612 60.1508 173.639 74.2436 170.619C84.3098 168.606 89.3429 166.593 93.3694 165.586C102.429 164.579 125.581 163.573 136.654 151.493Z"
            fill="#D3DCE3"
          />
          <path
            opacity="0.4286"
            d="M134.641 151.493C143.7 141.427 141.687 121.295 135.647 113.242C127.594 101.162 115.515 102.169 108.469 98.1423C102.429 95.1225 91.3561 83.043 82.2965 83.043C71.2237 82.0364 62.1641 85.0562 52.0979 88.0761C41.025 91.096 23.9125 108.209 16.8661 117.268C7.80651 127.334 3.78003 144.447 8.81314 150.487C13.8462 156.526 18.8794 162.566 28.9456 165.586C39.0118 168.606 45.0515 165.586 50.0846 166.593C55.1177 167.599 61.1575 171.626 75.2502 168.606C85.3164 166.593 90.3495 164.579 94.376 163.573C101.422 163.573 124.575 162.566 134.641 151.493Z"
            fill="#CDD8DF"
          />
          <path
            opacity="0.4762"
            d="M132.628 150.487C141.687 141.427 139.674 121.295 134.641 113.242C126.588 101.162 114.508 102.169 107.462 99.1489C101.422 96.1291 91.3561 85.0562 82.2965 84.0496C72.2303 83.043 62.1641 86.0629 52.0979 89.0827C41.025 92.1026 24.9191 109.215 16.8661 117.268C7.80651 126.328 3.78003 143.44 8.81314 149.48C12.8396 154.513 18.8794 161.559 28.9456 163.573C39.0118 165.586 45.0515 163.573 50.0846 164.579C54.1111 165.586 61.1575 169.612 75.2502 167.599C85.3164 165.586 90.3495 163.573 94.376 162.566C101.422 161.559 122.561 161.559 132.628 150.487Z"
            fill="#C8D3DC"
          />
          <path
            opacity="0.5238"
            d="M130.614 150.487C139.674 141.427 137.661 122.301 132.628 114.248C124.575 102.169 113.502 103.175 106.455 100.156C100.416 97.1357 91.3561 85.0562 82.2965 84.0496C72.2303 83.043 62.164 86.0629 52.0978 89.0827C41.025 92.1026 24.919 109.215 17.8727 116.262C9.81972 125.321 3.77999 141.427 9.81972 147.467C13.8462 152.5 18.8793 159.546 28.9455 161.559C39.0118 163.573 45.0515 160.553 49.078 161.559C53.1045 162.566 60.1508 166.593 74.2435 164.579C84.3097 162.566 89.3428 160.553 93.3693 159.546C100.416 160.553 120.548 160.553 130.614 150.487Z"
            fill="#C2CFD8"
          />
          <path
            opacity="0.5714"
            d="M129.608 149.48C138.667 141.427 137.661 122.301 131.621 114.248C123.568 102.169 112.495 103.175 105.449 100.156C99.4091 98.1423 90.3495 86.0628 81.2899 85.0562C71.2237 84.0496 61.1575 86.0629 51.0913 89.0827C40.0184 92.1026 24.9191 109.215 17.8727 116.262C10.8264 124.314 4.78665 140.42 10.8264 147.467C14.8529 152.5 19.886 158.54 29.9522 160.553C40.0184 162.566 46.0581 159.546 50.0846 160.553C54.1111 161.559 61.1575 165.586 74.2436 163.573C84.3098 161.559 90.3495 158.54 93.3694 158.54C100.416 158.54 119.542 159.546 129.608 149.48Z"
            fill="#BDCAD5"
          />
          <path
            opacity="0.619"
            d="M127.594 149.48C136.654 141.427 135.647 123.308 130.614 115.255C123.568 103.175 111.489 105.189 104.442 101.162C98.4024 99.1489 90.3494 87.0695 81.2899 86.0629C72.2303 85.0562 61.1574 87.0695 51.0912 90.0893C40.0184 93.1092 24.919 110.222 18.8793 116.262C11.8329 124.314 4.78659 138.407 10.8263 146.46C14.8528 151.493 19.8859 157.533 29.9521 159.546C40.0184 161.559 46.0581 157.533 50.0846 158.54C54.1111 159.546 61.1574 163.573 74.2435 161.559C84.3097 159.546 90.3494 156.526 93.3693 156.526C99.409 156.526 117.528 158.54 127.594 149.48Z"
            fill="#B7C6D1"
          />
          <path
            opacity="0.6667"
            d="M125.581 149.48C134.641 142.434 133.634 124.314 128.601 117.268C121.555 105.189 109.475 107.202 103.436 104.182C97.3959 100.156 89.3429 88.0761 81.2899 87.0695C72.2303 85.0562 61.1575 88.0761 51.0913 90.0893C40.0184 93.1092 25.9257 109.215 19.886 115.255C12.8397 122.301 4.78669 136.394 11.833 144.447C15.8595 148.473 19.886 155.52 29.9522 156.526C40.0184 158.54 45.0516 154.513 49.078 155.52C53.1045 156.526 60.1509 161.559 74.2436 158.54C84.3098 156.526 90.3495 153.507 93.3694 153.507C99.4091 155.52 115.515 156.526 125.581 149.48Z"
            fill="#B2C2CE"
          />
          <path
            opacity="0.7143"
            d="M123.568 148.473C132.628 141.427 131.621 124.314 127.595 117.268C120.548 105.189 109.475 107.202 102.429 104.182C96.3892 101.162 88.3363 89.0827 80.2833 88.0761C72.2303 86.0628 61.1575 88.0761 51.0913 91.096C40.0184 94.1158 25.9257 110.222 20.8926 116.262C14.8529 122.301 5.79328 136.394 11.833 144.447C14.8529 148.473 19.886 154.513 29.9522 156.526C40.0184 157.533 45.0515 153.507 49.078 154.513C53.1045 155.52 60.1509 160.553 74.2436 158.54C84.3098 156.526 90.3495 153.507 93.3694 153.507C98.4025 153.507 114.508 155.52 123.568 148.473Z"
            fill="#ACBDCA"
          />
          <path
            opacity="0.7619"
            d="M121.555 148.473C130.614 142.434 129.608 125.321 125.581 118.275C118.535 106.195 107.462 108.209 100.416 105.189C95.3826 103.175 87.3296 90.0894 79.2767 89.0827C72.2303 87.0695 60.1508 88.0761 51.0913 91.096C40.0184 95.1225 25.9257 110.222 20.8926 115.255C14.8529 121.295 5.79328 134.381 11.833 142.434C14.8529 146.46 18.8794 152.5 28.9456 153.507C39.0118 154.513 44.0449 150.487 48.0714 151.493C52.0979 152.5 59.1442 157.533 73.2369 155.52C84.3098 153.507 89.3429 150.487 92.3628 150.487C98.4025 152.5 112.495 154.513 121.555 148.473Z"
            fill="#A7B9C7"
          />
          <path
            opacity="0.8095"
            d="M120.548 147.467C129.608 141.427 129.608 125.321 124.575 118.275C117.528 106.195 106.455 108.209 100.416 106.195C95.3825 104.182 88.3362 91.096 80.2832 90.0893C71.2236 88.0761 60.1508 89.0827 51.0912 92.1026C40.0183 95.1225 26.9322 111.228 21.8991 115.255C16.866 120.288 5.79319 133.374 12.8395 141.427C15.8594 145.454 19.8859 150.487 29.9521 151.493C40.0183 152.5 45.0514 148.473 48.0713 149.48C52.0978 150.487 59.1441 155.52 73.2368 153.507C84.3097 151.493 89.3428 148.473 92.3627 148.473C97.3958 150.487 110.482 153.507 120.548 147.467Z"
            fill="#A1B5C3"
          />
          <path
            opacity="0.8571"
            d="M118.535 147.467C127.594 142.434 127.594 126.328 123.568 119.281C116.522 107.202 105.449 110.222 99.4091 107.202C94.376 105.189 88.3362 92.1026 80.2833 91.096C71.2237 88.0761 60.1508 89.0827 50.0846 92.1026C40.0184 95.1225 26.9323 111.228 22.9058 115.255C17.8727 120.288 6.79987 132.367 13.8462 141.427C16.8661 144.447 19.886 150.487 30.9588 151.493C41.025 152.5 46.0581 147.467 49.078 148.473C53.1045 149.48 60.1508 155.52 74.2435 152.5C85.3164 150.487 90.3495 146.46 93.3693 147.467C97.3958 149.48 109.475 152.5 118.535 147.467Z"
            fill="#9CB0C0"
          />
          <path
            opacity="0.9048"
            d="M116.522 146.46C125.581 141.427 125.581 126.328 121.555 119.281C114.508 107.202 103.435 110.222 97.3958 107.202C92.3627 105.189 86.3229 93.1092 79.2766 91.096C71.2236 89.0827 59.1441 90.0893 50.0845 93.1092C40.0183 96.1291 26.9322 111.228 23.9124 115.255C19.8859 119.281 7.80643 131.361 14.8528 140.42C17.8726 143.44 20.8925 149.48 30.9587 149.48C41.0249 150.487 46.0581 145.454 49.0779 146.46C53.1044 147.467 60.1508 153.507 74.2435 151.493C85.3163 149.48 90.3494 145.454 93.3693 146.46C96.3891 147.467 107.462 151.493 116.522 146.46Z"
            fill="#96ACBC"
          />
          <path
            opacity="0.9524"
            d="M114.508 146.46C123.568 142.434 123.568 127.334 119.542 120.288C112.495 108.209 102.429 111.228 95.3826 108.209C91.3562 106.195 85.3164 93.1092 77.2635 91.096C71.2237 90.0893 59.1443 90.0893 50.0847 93.1092C40.0185 96.1291 27.939 111.228 23.9125 114.248C19.886 118.275 6.79995 129.348 14.8529 138.407C16.8662 141.427 20.8926 147.467 30.9589 147.467C42.0317 147.467 46.0582 142.434 48.0714 143.44C52.0979 145.454 59.1443 150.487 73.237 148.473C84.3098 146.46 89.3429 142.434 91.3562 143.44C96.3893 146.46 105.449 150.487 114.508 146.46Z"
            fill="#91A7B9"
          />
          <path
            d="M112.495 145.454C121.555 141.427 122.561 127.334 118.535 120.288C111.489 108.209 101.422 111.228 95.3826 109.215C91.3561 107.202 85.3163 94.1158 78.27 92.1026C71.2236 90.0893 59.1442 91.096 50.0846 94.1158C40.0184 97.1357 27.9389 112.235 24.919 115.255C20.8926 118.275 7.80647 129.348 15.8594 138.407C17.8727 140.42 20.8926 145.454 30.9588 146.46C42.0316 146.46 45.0515 141.427 48.0713 142.434C52.0978 144.447 59.1442 149.48 73.2369 147.467C84.3097 145.454 89.3428 141.427 91.3561 142.434C95.3826 144.447 104.442 149.48 112.495 145.454Z"
            fill="#8BA3B5"
          />
        </g>
        <path
          d="M104.442 105.189C102.429 105.189 99.4091 105.189 97.3959 106.195C94.376 92.1026 82.2965 81.0298 66.1906 80.0231C51.0913 79.0165 38.0052 88.0761 32.9721 102.169C20.8926 101.162 9.81977 111.228 8.81315 124.314C7.80653 137.401 17.8727 148.473 30.9588 148.473C38.0052 148.473 44.0449 146.46 48.0714 142.434C52.0979 145.454 57.131 146.46 63.1707 146.46C73.2369 147.467 82.2965 143.44 88.3363 136.394C91.3561 140.42 96.3892 143.44 102.429 143.44C113.502 144.447 122.561 135.387 122.561 125.321C123.568 115.255 115.515 106.195 104.442 105.189Z"
          fill="white"
        />
        <defs>
          <linearGradient
            id="paint0_linear_2_1880"
            x1="103.18"
            y1="13.8378"
            x2="119.998"
            y2="30.6554"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#FFD45C" />
            <stop offset="1" stopColor="#FF9D00" />
          </linearGradient>
          <linearGradient
            id="paint1_linear_2_1880"
            x1="103.18"
            y1="131.053"
            x2="119.998"
            y2="147.87"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#FFD45C" />
            <stop offset="1" stopColor="#FF9D00" />
          </linearGradient>
          <linearGradient
            id="paint2_linear_2_1880"
            x1="44.5714"
            y1="72.4423"
            x2="61.389"
            y2="89.2599"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#FFD45C" />
            <stop offset="1" stopColor="#FF9D00" />
          </linearGradient>
          <linearGradient
            id="paint3_linear_2_1880"
            x1="161.783"
            y1="72.4423"
            x2="178.601"
            y2="89.2599"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#FFD45C" />
            <stop offset="1" stopColor="#FF9D00" />
          </linearGradient>
          <linearGradient
            id="paint4_linear_2_1880"
            x1="64.085"
            y1="116.223"
            x2="76.2145"
            y2="128.353"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#FFD45C" />
            <stop offset="1" stopColor="#FF9D00" />
          </linearGradient>
          <linearGradient
            id="paint5_linear_2_1880"
            x1="146.963"
            y1="33.3445"
            x2="159.093"
            y2="45.474"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#FFD45C" />
            <stop offset="1" stopColor="#FF9D00" />
          </linearGradient>
          <linearGradient
            id="paint6_linear_2_1880"
            x1="141.163"
            y1="110.423"
            x2="164.894"
            y2="134.154"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#FFD45C" />
            <stop offset="1" stopColor="#FF9D00" />
          </linearGradient>
          <linearGradient
            id="paint7_linear_2_1880"
            x1="58.2848"
            y1="27.5444"
            x2="82.0156"
            y2="51.2753"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#FFD45C" />
            <stop offset="1" stopColor="#FF9D00" />
          </linearGradient>
          <linearGradient
            id="paint8_linear_2_1880"
            x1="156.968"
            y1="94.5114"
            x2="174.505"
            y2="112.049"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#FFBB31" />
            <stop offset="1" stopColor="#FF9D00" />
          </linearGradient>
          <linearGradient
            id="paint9_linear_2_1880"
            x1="48.6773"
            y1="49.6564"
            x2="66.2137"
            y2="67.1927"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#FFBB31" />
            <stop offset="1" stopColor="#FF9D00" />
          </linearGradient>
          <linearGradient
            id="paint10_linear_2_1880"
            x1="80.39"
            y1="17.9337"
            x2="97.9293"
            y2="35.4731"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#FFBB31" />
            <stop offset="1" stopColor="#FF9D00" />
          </linearGradient>
          <linearGradient
            id="paint11_linear_2_1880"
            x1="125.246"
            y1="126.228"
            x2="142.783"
            y2="143.765"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#FFBB31" />
            <stop offset="1" stopColor="#FF9D00" />
          </linearGradient>
          <linearGradient
            id="paint12_linear_2_1880"
            x1="52.2448"
            y1="98.0829"
            x2="62.6392"
            y2="108.477"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#FFBB31" />
            <stop offset="1" stopColor="#FF9D00" />
          </linearGradient>
          <linearGradient
            id="paint13_linear_2_1880"
            x1="160.534"
            y1="53.2269"
            x2="170.93"
            y2="63.6222"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#FFBB31" />
            <stop offset="1" stopColor="#FF9D00" />
          </linearGradient>
          <linearGradient
            id="paint14_linear_2_1880"
            x1="83.9655"
            y1="129.802"
            x2="94.3568"
            y2="140.193"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#FFBB31" />
            <stop offset="1" stopColor="#FF9D00" />
          </linearGradient>
          <linearGradient
            id="paint15_linear_2_1880"
            x1="128.82"
            y1="21.5082"
            x2="139.212"
            y2="31.8996"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#FFBB31" />
            <stop offset="1" stopColor="#FF9D00" />
          </linearGradient>
          <linearGradient
            id="paint16_linear_2_1880"
            x1="77.8049"
            y1="47.0684"
            x2="145.371"
            y2="114.635"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#FFD45C" />
            <stop offset="1" stopColor="#FF9D00" />
          </linearGradient>
        </defs>
      </svg>
    </div>
  );
}

export default partlyCloudy;
